{
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "retry": "Retry",
    "dismiss": "Dismiss",
    "confirm": "Confirm",
    "delete": "Delete",
    "deleting": "Deleting…",
    "creating": "Creating…",
    "edit": "Edit",
    "you": "You",
    "signOut": "Sign out",
    "backToHome": "Back to Home",
    "pleaseTryAgain": "Please try again.",
    "copy": "Copy",
    "noWorkspaceSelected": "No workspace selected.",
    "color": "Color",
    "reset": "Reset",
    "discard": "Discard",
    "discardChangesTitle": "Discard your changes?",
    "discardChangesBody": "You have edits you have not saved. Closing now throws them away.",
    "saving": "Saving",
    "diff": {
      "summary": "{removed} removed · {added} added"
    },
    "back": "Back",
    "next": "Next",
    "sortBy": "Sort by",
    "sortAsc": "Sorted ascending",
    "sortDesc": "Sorted descending",
    "table": {
      "range": "{from}-{to} of {total}",
      "pageSize": "Rows per page",
      "previous": "Previous page",
      "next": "Next page",
      "selectRow": "Select row",
      "empty": "Nothing to show yet"
    },
    "copyFailed": "Could not copy"
  },
  "errors": {
    "somethingWentWrong": "Something went wrong.",
    "offline": "You're offline. Check your connection and try again.",
    "rateLimited": "Too many requests. Please wait a moment and try again.",
    "sessionExpired": "Your session has expired. Please sign in again.",
    "notFoundTitle": "Page not found",
    "notFoundDescription": "The page you're looking for doesn't exist.",
    "unknownError": "An unknown error occurred.",
    "planRun": {
      "enqueueFailed": "Raldo could not start the plan. Try again.",
      "inProgress": "A plan is already running. Wait for it to finish.",
      "failed": "The plan stopped on an error. Try again.",
      "domainUnknown": "Raldo does not know your website yet. Add it first.",
      "marketUndecided": "Choose the market you sell in first.",
      "siteUnreachable": "Raldo could not reach your website. Check that it is online.",
      "rawStoreFailed": "Raldo could not save what it found. Try again.",
      "stageDeadlineExceeded": "A step took too long. Try again.",
      "vendorBudgetExhausted": "Search data is not available right now. Try again later.",
      "vendorNotConfigured": "Search data is not set up yet.",
      "vendorHttpError": "The search data service did not answer. Try again later.",
      "vendorEnvelopeError": "The search data service sent a bad answer. Try again later.",
      "contentFetchFailed": "Raldo could not read your pages. Try again.",
      "beliefsMissing": "Raldo needs your arguments first. Set them up and try again.",
      "brandFactsMissing": "Raldo needs your brand facts first. Fill them in and try again.",
      "discoveryNoSeeds": "Raldo found no searches to start from. Try again.",
      "modelOutputInvalid": "Raldo got an answer it could not use. Try again.",
      "timedOut": "The plan took too long. Try again.",
      "relevanceNothingKept": "No search scored high enough for your company. Check your brand facts and try again.",
      "serpNoResults": "Raldo got no search results back. Try again later.",
      "noPagesKept": "Every page was left out. Check your brand facts and try again.",
      "focusNothingNew": "No new pages were found for this topic."
    },
    "visibilityRun": {
      "enqueueFailed": "Raldo could not start the measurement. Try again.",
      "inProgress": "A measurement is already running. Wait for it to finish.",
      "failed": "The measurement stopped on an error. Try again.",
      "noPrompts": "Raldo found no questions to ask. Check your plan and try again.",
      "noPlan": "Raldo needs your plan first. Plan your pages and try again.",
      "costCap": "The measurement stopped early, so some answers are missing.",
      "marketUndecided": "Choose the market you sell in first.",
      "brandFactsMissing": "Raldo needs your brand facts first. Fill them in and try again.",
      "modelOutputInvalid": "Raldo got an answer it could not use. Try again.",
      "rawStoreFailed": "Raldo could not save what it found. Try again.",
      "stageDeadlineExceeded": "A step took too long. Try again.",
      "vendorBudgetExhausted": "AI answers are not available right now. Try again later.",
      "vendorNotConfigured": "AI answers are not set up yet.",
      "vendorHttpError": "The AI answer service did not answer. Try again later.",
      "vendorEnvelopeError": "The AI answer service sent a bad answer. Try again later.",
      "contentFetchFailed": "Raldo could not read your pages. Try again.",
      "timedOut": "The measurement took too long. Try again."
    },
    "articleRun": {
      "enqueueFailed": "Raldo could not start the page. Try again.",
      "inProgress": "This page is already being written. Wait for it to finish.",
      "failed": "The page stopped on an error. Try again.",
      "rawStoreFailed": "Raldo could not save what it found. Try again.",
      "stageDeadlineExceeded": "A step took too long. Try again.",
      "pageUnknown": "Raldo does not know this page. Plan your pages again.",
      "noPlanRun": "Raldo needs a finished plan first. Plan your pages and try again.",
      "noSources": "Raldo could not read any page that ranks for this question. Try again later.",
      "noScope": "Raldo found nothing the page should cover. Check the question and try again.",
      "brandFactsMissing": "Raldo needs your brand facts first. Fill them in and try again.",
      "marketUndecided": "Choose the market you sell in first.",
      "modelOutputInvalid": "Raldo got an answer it could not use. Try again.",
      "vendorBudgetExhausted": "Research is not available right now. Try again later.",
      "vendorNotConfigured": "Research is not set up yet.",
      "vendorHttpError": "The research service did not answer. Try again later.",
      "vendorEnvelopeError": "The research service sent a bad answer. Try again later.",
      "contentFetchFailed": "Raldo could not read a page. Try again.",
      "timedOut": "The page took too long. Try again."
    },
    "postRun": {
      "enqueueFailed": "Raldo could not start the post. Try again.",
      "inProgress": "A post is already being written. Wait for it to finish.",
      "failed": "The post stopped on an error. Try again.",
      "rawStoreFailed": "Raldo could not save its work. Try again.",
      "stageDeadlineExceeded": "A step took too long. Try again.",
      "briefFailed": "Raldo could not write a brief that keeps the rules. Try again.",
      "noBelief": "Your strategy has no argument for this post yet.",
      "topicNotLinked": "This argument is not linked to a topic yet. Link it to a topic first.",
      "beliefMapMissing": "Your strategy has no arguments yet.",
      "brandFactsMissing": "Your brand facts are not confirmed yet.",
      "marketUndecided": "Your brand has no market yet.",
      "modelOutputInvalid": "Raldo's answer did not keep the rules. Try again.",
      "timedOut": "The post stopped reporting and was ended."
    }
  },
  "routes": {
    "chat": "Chat",
    "chats": "Past chats",
    "document": "Document",
    "design": "Design",
    "competitor": "Competitor",
    "signIn": "Sign In",
    "checkYourEmail": "Check Your Email",
    "signingIn": "Signing In",
    "yourName": "Your Name",
    "workspaceSetup": "Workspace Setup",
    "setup": "Setup",
    "knowledge": "Knowledge",
    "publishingSchedule": "Publishing schedule"
  },
  "nav": {
    "chat": "Chat",
    "content": "Content",
    "media": "Media",
    "account": "Account",
    "description": {
      "content": "Your posts and pages, week by week.",
      "media": "A little drawer for everything visual.",
      "competitors": "The other names your buyers consider, and how you compare.",
      "arguments": "The case you make, one argument at a time.",
      "chats": "Pick up any conversation where you left off.",
      "documents": "A shelf of background reading for Raldo.",
      "look": "The colours and type people know you by.",
      "voice": "Your voice, so nothing ever sounds borrowed.",
      "inbox": "What needs you, and what Raldo did while you were away.",
      "plan": "Your rhythm.",
      "customer": "The person on the other side of every post.",
      "settings": "The behind-the-scenes bits, all in one place.",
      "company": "What Raldo learned about you.",
      "visibility": "Can buyers find you? Let's have a look.",
      "pages": "Every page of your content plan, by topic, in the order Raldo writes them.",
      "posts": "Every post, with a date or without."
    },
    "style": "Style",
    "profile": "Profile",
    "strategy": "Strategy",
    "topics": "Topics",
    "arguments": "Arguments",
    "calendar": "Board",
    "voice": "Voice",
    "look": "Visual style",
    "brand": "Brand",
    "knowledge": "Knowledge",
    "inbox": "Inbox",
    "settings": "Settings",
    "visibility": "Visibility",
    "competitors": "Competitors",
    "kind": {
      "argument": "Argument",
      "keyword": "Keyword",
      "prompt": "Prompt",
      "topic": "Topic",
      "rival": "Rival",
      "page": "Page",
      "researchEntry": "Research entry",
      "post": "Post"
    },
    "research": "Research",
    "pages": "Pages",
    "posts": "Posts"
  },
  "shell": {
    "guestName": "Placeholder",
    "guestEmail": "you{'@'}raldo.app",
    "brandPlaceholder": "Your brand",
    "sidebar": "Sidebar",
    "collapseSidebar": "Collapse sidebar",
    "expandSidebar": "Expand sidebar",
    "primaryNav": "Primary",
    "resizeSidebar": "Resize the side nav",
    "resizeSidebarHint": "Drag to resize · Click to collapse",
    "expandSidebarHint": "Click to expand",
    "darkTheme": "Dark theme"
  },
  "auth": {
    "raldoHome": "Raldo home",
    "or": "or",
    "continueWithGoogle": "Continue with Google",
    "openingGoogleSignIn": "Opening Google sign-in",
    "continue": "Continue",
    "email": "Email",
    "emailPlaceholder": "your{'@'}email.com",
    "termsOfService": "Terms of Service",
    "privacyPolicy": "Privacy Policy",
    "legal": "By signing in you agree to our {terms} and {privacy}",
    "signIn": {
      "title": "Let's get you started",
      "subtitle": "Create an account or sign in.",
      "emailError": "Enter a valid email address",
      "sendingLink": "Sending your sign-in link"
    },
    "emailSent": {
      "resendCooldown": "Resend in {seconds}s",
      "linkSent": "Link sent ✓",
      "resendLink": "Resend link",
      "title": "Check your inbox",
      "sentTo": "We sent a magic link to",
      "expiry": "Click the link in the email to sign in. The link expires in 30 minutes.",
      "resending": "Resending your link",
      "useDifferentEmail": "← Use a different email"
    },
    "fullName": {
      "required": "Please enter your name.",
      "title": "What's your name?",
      "subtitle": "We'll use this to personalize your workspace.",
      "label": "Full name",
      "placeholder": "John Smith",
      "saving": "Saving your name"
    },
    "workspaceSetup": {
      "workspaceNameRequired": "Enter a workspace name.",
      "brandNameRequired": "Enter a brand name.",
      "title": "Set up your workspace",
      "subtitle": "You're almost there. Give your workspace a name to get started.",
      "workspaceNameLabel": "Workspace name",
      "workspaceNamePlaceholder": "Acme Corp",
      "brandNameLabel": "Brand name",
      "brandNamePlaceholder": "e.g. Acme",
      "sameAsWorkspace": "Same as workspace",
      "submitting": "Setting up…",
      "continueCta": "Continue →"
    },
    "callback": {
      "signingIn": "Signing you in…",
      "signingInLoading": "Signing you in",
      "confirmTitle": "Confirm your email to continue",
      "confirmBody": "It looks like you opened this link on a different device. Enter your email to complete sign-in."
    },
    "toast": {
      "magicLinkFailed": "Could not send sign-in link",
      "googleSignInFailed": "Google sign-in failed",
      "resendFailed": "Could not resend link",
      "saveNameFailed": "Could not save your name",
      "createWorkspaceFailed": "Could not create your workspace",
      "signInFailed": "Could not sign you in",
      "linkExpired": "The link may have expired. Enter your email to try again."
    },
    "errors": {
      "noEmailOnFile": "No email on file to complete the magic-link sign-in with."
    }
  },
  "billing": {
    "yearly": "Yearly",
    "monthly": "Monthly",
    "billedOnceYear": "{price} billed once a year",
    "billedEveryMonth": "Billed every month",
    "perMonth": "/month",
    "perYear": "/year",
    "planOptionAriaLabel": "{name}, {price} per month, {note}",
    "billingTerm": "Billing term",
    "headline": "Never miss a post.",
    "chooseBilling": "Choose your billing",
    "vatNote": "Prices exclude VAT. Any tax due is calculated at checkout.",
    "checkoutCta": "Put Raldo to work",
    "checkoutLoading": "Taking you to checkout",
    "secureCheckout": "Secure checkout by Stripe · Cancel anytime",
    "tagline": "The agentic marketing platform",
    "checkoutError": "Something went wrong starting checkout. Please try again.",
    "title": "Billing",
    "confirming": "Confirming your payment",
    "confirmingHeading": "Confirming your payment…",
    "confirmingBody": "This normally takes just a second or two.",
    "stillConfirming": "Still confirming your payment",
    "stillConfirmingBody": "Your payment may still be processing. This can occasionally take a little longer than usual - check again in a moment, or reach out if it doesn't clear up.",
    "checkAgain": "Check again",
    "contactSupport": "Contact support",
    "twoMonthsFree": "2 months free",
    "trialEnded": "Your trial ended on {date}.",
    "accessCode": {
      "trigger": "Have an access code?",
      "placeholder": "Access code",
      "apply": "Apply",
      "ariaLabel": "Access code",
      "invalid": "That access code isn't valid. Check it and try again.",
      "expired": "That access code has expired.",
      "exhausted": "That access code has already been used up.",
      "alreadyMember": "Your workspace already has access.",
      "alreadyRedeemed": "This workspace has already used an access code.",
      "paymentRecovery": "Your membership has a payment issue. Fix it in the billing portal."
    },
    "benefits": {
      "unlimitedTitle": "Unlimited content",
      "unlimitedBody": "Draft, design and schedule as much as you like. No credits, no caps, no metering.",
      "supportTitle": "Real human support, 24/7",
      "supportBody": "Actual people, whenever you need them. Response time in less than 1h.",
      "guaranteeTitle": "{days}-day money-back guarantee",
      "guaranteeBody": "No questions asked."
    }
  },
  "account": {
    "membership": "Raldo Membership",
    "status": {
      "active": "Active",
      "endsSoon": "Ends soon",
      "paymentIssue": "Payment issue",
      "cancelled": "Cancelled",
      "pending": "Pending"
    },
    "renewsOn": "Renews on {date}",
    "accessEndsOn": "Access ends on {date}",
    "staysUsable": "Your membership stays fully usable until then.",
    "memberSince": "Member since {date}",
    "trial": {
      "badge": "Trial · {count} day left | Trial · {count} days left",
      "endsOn": "Trial ends {date}",
      "thenPrice": "after the trial",
      "choosePlan": "Choose a plan",
      "endTrial": "End trial",
      "endDialogTitle": "End your trial?",
      "endDialogWithDate": "You'll keep full access until {date}. After that, your trial ends.",
      "endDialogWithoutDate": "You'll keep full access until your trial ends. After that, your access stops."
    },
    "manageBilling": "Manage billing",
    "cancelSubscription": "Cancel subscription",
    "resumeSubscription": "Resume subscription",
    "market": {
      "title": "Search market",
      "description": "Where Raldo measures rankings, keywords and rivals. One country per content language.",
      "current": "Current market",
      "source": {
        "languageDefault": "Default for {language}",
        "overview": "Chosen from where you rank",
        "user": "Set by you"
      },
      "decided": "decided {date}",
      "candidates": "Where your site ranks",
      "candidateTraffic": "{traffic} visits/mo",
      "candidateKeywords": "no keywords | 1 keyword | {count} keywords",
      "selectLabel": "Country",
      "rereadNote": "Changing the market re-reads your search data on the next measurement.",
      "ownerOnly": "Only owners and admins can change the market.",
      "saving": "Saving the market",
      "emptyTitle": "Confirm your brand facts to set the market",
      "toast": {
        "saved": "Search market updated"
      }
    },
    "profile": "Profile",
    "email": "Email",
    "nameLabel": "Name",
    "namePlaceholder": "Your name",
    "toast": {
      "nameUpdated": "Name updated",
      "updateNameFailed": "Failed to update name",
      "cancelDialogTitle": "Cancel your subscription?",
      "cancelDialogWithDate": "You'll keep full access until {date}. After that, your membership ends.",
      "cancelDialogWithoutDate": "You'll keep full access until the end of the current billing period. After that, your membership ends.",
      "membershipEndsOn": "Your membership ends on {date}.",
      "membershipCancelled": "Your membership has been cancelled.",
      "cancelFailed": "Failed to cancel subscription",
      "membershipRenews": "Your membership will renew as usual.",
      "resumeFailed": "Failed to resume subscription",
      "billingPortalFailed": "Failed to open billing portal"
    }
  },
  "brand": {
    "connectedSince": "Connected since {date}",
    "disconnect": "Disconnect",
    "ownerOnly": "Only workspace owners can manage connections.",
    "coreMessage": "Core message",
    "opportunity": "Opportunity",
    "foundationNote": "Foundation: every topic backed by proof points and performance data",
    "account": "Account",
    "linkedinDescription": "Publish posts and carousels straight to your company page.",
    "connectCta": "Connect {platform}",
    "toast": {
      "loadStatusFailed": "Failed to load connection status",
      "connectFailed": "Failed to connect {platform}",
      "disconnected": "{platform} disconnected",
      "disconnectFailed": "Failed to disconnect {platform}",
      "saveFailed": "Could not save this change",
      "viewerRoleMessage": "Your role can read this brand, but not change it.",
      "markUploadFailed": "Could not upload this file"
    },
    "dialog": {
      "disconnectTitle": "Disconnect {platform}?",
      "disconnectLinkedinBody": "Disconnecting LinkedIn stops Raldo from publishing to your company page. You can reconnect any time."
    },
    "generating": "Writing this…",
    "section": {
      "edit": "Edit",
      "editSection": "Edit {section}",
      "saving": "Saving"
    },
    "visualStyle": {
      "paletteTitle": "Palette",
      "paletteDescription": "The first colour is the primary. Raldo uses it for headlines and key shapes.",
      "primaryColor": "Primary",
      "colorAt": "Colour {index}",
      "noColors": "No colours yet.",
      "removeColor": "Remove {role}",
      "addColor": "Add a colour",
      "typefaceTitle": "Typeface",
      "typefaceDescription": "Applied to every design Raldo makes for this brand.",
      "fontFamilyLabel": "Type family",
      "marksTitle": "Marks",
      "marksDescription": "Raldo picks the monogram when a design is small or square.",
      "logoMark": "Logo",
      "monogramMark": "Monogram",
      "onLight": "On light",
      "onDark": "On dark",
      "noMarks": "No marks yet.",
      "replaceMark": "Replace",
      "addMark": "Add {mark}",
      "removeMark": "Remove {mark}",
      "uploadingMark": "Uploading...",
      "errors": {
        "invalidFileType": "This file type is not supported. Upload a PNG, JPEG, SVG or WebP image.",
        "fileTooLarge": "This file is too large. The maximum size is 2MB.",
        "uploadFailed": "Something went wrong uploading this file. Try again."
      },
      "quickLook": {
        "file": "File",
        "dimensions": "Dimensions",
        "groundAriaLabel": "Preview ground",
        "openAria": "Open {mark} preview"
      },
      "removeMarkAction": "Remove"
    },
    "styleGuide": {
      "outlineLabel": "Parts of this guide",
      "notSet": "Not written yet.",
      "sectionPlaceholder": "What this brand does about {section}",
      "termsDescription": "Raldo corrects these before a draft reaches you.",
      "preferencesDescription": "Raldo refuses to write any word on the right.",
      "sampleCopyDescription": "From your own posts. Evidence behind the sections above, kept as published.",
      "writtenWrongly": "Written wrongly",
      "correctForm": "Correct form",
      "termPlaceholder": "e.g. meridian",
      "correctFormPlaceholder": "e.g. Meridian",
      "addTerm": "Add a term",
      "useInstead": "Use",
      "avoid": "Never",
      "useInsteadPlaceholder": "e.g. name the step it removes",
      "avoidPlaceholder": "e.g. seamless",
      "addWord": "Add a word",
      "removeRule": "Remove {rule}",
      "noRulesYet": "Raldo reads these from your published posts. Connect an account and it will fill this in.",
      "connectAccounts": "Connected accounts",
      "viewOriginalPost": "View the original post",
      "noSampleCopy": "No sample copy yet.",
      "parts": {
        "voiceAndPersonality": "Voice and personality",
        "formalityAndAddress": "Formality and address",
        "referenceGrammarStandard": "Grammar standard",
        "numbersDatesCurrency": "Numbers, dates and currency",
        "punctuationAndQuotes": "Punctuation and quotes",
        "capitalization": "Capitalization",
        "inclusiveLanguage": "Inclusive language",
        "brandAndProductTerms": "Brand and product terms",
        "preferredAndAvoidedWords": "Words to prefer and avoid",
        "sampleCopy": "Sample copy"
      },
      "outline": {
        "voice": "Voice",
        "mechanics": "Mechanics",
        "rules": "Rules",
        "evidence": "Evidence"
      }
    },
    "discardTitle": "Discard your changes?",
    "discardBody": "This brief has edits you have not saved. Leaving now throws them away.",
    "discardConfirm": "Discard",
    "artifacts": {
      "contentStrategy": "Content strategy",
      "look": "Visual style",
      "voice": "Voice",
      "beliefs": "Arguments"
    },
    "notWritten": {
      "title": "{artifact} has not been written yet",
      "description": "Raldo writes this in conversation. Ask for it on Home and it will appear here.",
      "action": "Ask Raldo",
      "askMessage": "Write my {artifact}."
    },
    "connections": {
      "title": "Connections",
      "description": "Where Raldo publishes on your behalf."
    },
    "schedule": {
      "title": "Publishing schedule",
      "timeZoneLabel": "Time zone",
      "timeZoneHint": "Every time below is read in this zone.",
      "toggleDay": "Post on {day}",
      "timeFor": "Publishing time on {day}",
      "apply": "Apply",
      "days": {
        "monday": "Mon",
        "tuesday": "Tue",
        "wednesday": "Wed",
        "thursday": "Thu",
        "friday": "Fri",
        "saturday": "Sat",
        "sunday": "Sun"
      },
      "setEveryDayTo": "Set every day to",
      "everyDayTimeLabel": "Time to apply to every day"
    },
    "telegram": {
      "name": "Telegram",
      "description": "Chat with Raldo from your phone. Log notes, photos and voice notes on the go.",
      "connectTitle": "Connect Telegram",
      "connectBody": "Scan with your phone camera. Telegram opens and links this brand automatically.",
      "qrAlt": "QR code that opens Raldo in Telegram",
      "codeExpires": "This code expires in 15 minutes and works once.",
      "emailLink": "Email me the link"
    },
    "beliefMap": {
      "untitled": "Untitled argument",
      "roofPlaceholder": "State it so a reader could disagree",
      "nameLabel": "Name",
      "namePlaceholder": "e.g. The pipeline conversion tax",
      "claimLabel": "What they must believe",
      "claimHint": "One or two sentences, stated as something a thoughtful reader could disagree with.",
      "claimPlaceholder": "Describe what the reader has to come to accept",
      "objectionLabel": "What they believe instead",
      "objectionHint": "The position this argument has to defeat, in their words and at its strongest. Without it the writing has nothing to push against.",
      "objectionPlaceholder": "e.g. Posting is vanity - my deals come from referrals",
      "add": "Add an argument",
      "beliefCount": "no arguments | 1 argument | {count} arguments",
      "phaseLabel": "Journey phase",
      "notFoundTitle": "That argument does not exist",
      "notFoundBody": "It may have been deleted, or the link may be wrong.",
      "phases": {
        "awareness": {
          "name": "Awareness",
          "question": "Is this actually a problem, and is it mine?",
          "empty": "No arguments yet for the reader who doesn't know this is a problem."
        },
        "consideration": {
          "name": "Comparison",
          "question": "What are my options, and why isn't the obvious one right?",
          "empty": "No arguments yet for the reader weighing their options."
        },
        "decision": {
          "name": "Decision",
          "question": "Can I trust them, and is acting safe?",
          "empty": "No arguments yet for the reader deciding whether to act."
        }
      }
    },
    "templates": {
      "loading": "Loading your templates",
      "loadError": "Could not load your templates",
      "emptyTitle": "No templates yet",
      "emptyDescription": "Ready-made layouts will collect here, so a post can look like your brand without being drawn twice."
    },
    "competitors": {
      "runComparison": "Run comparison",
      "runStarted": "Raldo compares you against your rivals again. This can take a few minutes.",
      "runFailed": "The comparison could not run",
      "addRival": "Add a rival",
      "atLimitReason": "You're tracking the maximum of {max} rivals. Stop tracking one to add another.",
      "loadRivalsError": "Could not load your tracked rivals",
      "loadReportError": "Could not generate your competitor comparison",
      "emptyNoRivals": {
        "title": "No rivals tracked yet",
        "description": "Track a rival's domain to see how you compare in search and in AI answers."
      },
      "emptyNoReport": {
        "title": "Run your first comparison",
        "description": "Raldo compares your tracked rivals against your own domain using search and AI data. This can take a few minutes."
      },
      "emptyDomainUnknown": {
        "title": "Raldo needs your website first",
        "description": "Comparing you against rivals starts from your own domain, which Raldo reads from your website. Add it in your brand facts.",
        "cta": "Go to brand facts"
      },
      "status": {
        "notCompared": "Not compared yet",
        "failed": "Comparison failed"
      },
      "figures": {
        "share": "Your share of search",
        "shareSub": "Of {count} keyword your rivals rank for | Of {count} keywords your rivals rank for",
        "aiShare": "Named in AI answers",
        "aiShareSub": "{named} of {answers} answer names you | {named} of {answers} answers name you",
        "keywords": "Keywords you rank for",
        "keywordsSub": "{name} ranks for {count}",
        "gaps": "Gaps to close",
        "gapsLink": "See them in Search",
        "gapsHint": "Keywords a rival ranks for and you don't"
      },
      "table": {
        "title": "You and your rivals",
        "meta": "Compared on {date} · {count} of {max} tracked",
        "site": "Site",
        "share": "Share of search",
        "keywords": "Keywords",
        "shared": "Shared",
        "googleAi": "Google AI",
        "aiAnswers": "AI answers",
        "ofCount": "{value} of {count}",
        "hints": {
          "share": "Position-weighted share of the search volume you compete on",
          "keywords": "Keywords the site ranks for on Google",
          "shared": "Keywords both you and they rank for",
          "googleAi": "Keywords where Google's AI Overview cites the site",
          "aiAnswers": "Share of the AI answers that name a tracked brand"
        }
      },
      "chart": {
        "title": "Share of search over time",
        "meta": "At each comparison",
        "aria": "Share of search at each comparison, you against your rivals"
      },
      "addDialog": {
        "description": "Raldo compares them against you in search and in AI answers. You track {count} of {max}.",
        "field": "Company or website",
        "placeholder": "Search by name, or paste their website",
        "confirm": "Track rival",
        "tracked": "Tracked",
        "added": "{name} is tracked. Run a comparison to include them."
      },
      "addField": {
        "label": "Add a competitor",
        "placeholder": "Company name or website",
        "hint": "Type a company name or website. Press Enter to search.",
        "search": "Search",
        "searching": "Searching",
        "noResults": "No company found for “{query}”.",
        "tooLong": "Use {max} characters or fewer.",
        "failed": "The search did not work. Try again.",
        "duplicate": "{name} is already on the list.",
        "resultsLabel": "Companies found"
      },
      "rival": {
        "trackedSince": "Tracked since {date}",
        "positioning": "Their positioning",
        "openSite": "Open site",
        "stopTracking": "Stop tracking",
        "stopTrackingAria": "Stop tracking {name}",
        "stopTrackingTitle": "Stop tracking {name}?",
        "stopTrackingBody": "Raldo stops tracking this rival and the next comparison will not include them. You can track them again any time.",
        "stopTrackingFailed": "Could not stop tracking {name}",
        "notFoundTitle": "Rival not found",
        "notFoundBody": "It may have been removed, or the link may be wrong.",
        "back": "Back to Competitors",
        "notComparedTitle": "Not compared yet",
        "notComparedBody": "Raldo hasn't compared this rival yet. Run a comparison to see where you stand.",
        "failedTitle": "Couldn't compare this rival",
        "failedBody": "The last comparison failed for this site. Run it again; if it keeps failing, check the website address.",
        "figures": {
          "share": "Their share of search",
          "yours": "Yours is {value}",
          "visits": "Visits a month from Google",
          "visitsSub": "Estimated",
          "keywords": "Keywords they rank for",
          "keywordsSub": "You rank for {count}",
          "aiShare": "Their share of AI answers"
        },
        "overlap": {
          "title": "Where your keywords overlap",
          "meta": "{count} keyword in all | {count} keywords in all",
          "aria": "{ours} only you rank for, {shared} you both rank for, {theirs} only they rank for",
          "ours": "only you rank for",
          "shared": "you both rank for",
          "theirs": "only they rank for"
        },
        "winnable": {
          "title": "Keywords you can win from them",
          "meta": "They rank, and it's not hard to win",
          "rank": "Their rank",
          "inPlan": "On a page of your plan",
          "notInPlan": "Not in your plan yet",
          "emptyTitle": "No keyword to win from them yet"
        },
        "topics": {
          "title": "Topic standing",
          "meta": "Average rank on Google, lower is better",
          "topic": "Topic",
          "theirKeywords": "Their keywords",
          "theirRank": "Their avg. rank",
          "yourKeywords": "Your keywords",
          "yourRank": "Your avg. rank",
          "rank": "#{rank}",
          "emptyTitle": "No topic standing yet"
        },
        "pages": {
          "title": "Their best pages",
          "meta": "By estimated visits from Google",
          "page": "Page",
          "visits": "Visits/mo",
          "keywords": "Keywords",
          "emptyTitle": "No page with visits from Google yet"
        },
        "prompts": {
          "title": "Prompts where AI names {name}",
          "seeAll": "See all prompts",
          "emptyTitle": "No AI answer names them",
          "emptyBody": "None of this month's prompts led ChatGPT or Perplexity to name them.",
          "prompt": "Prompt",
          "namedBy": "Named by"
        },
        "aiTopics": {
          "title": "{name} in AI answers by topic",
          "meta": "Prompts that name {name} are left out · {period}",
          "topic": "Topic"
        }
      }
    },
    "company": {
      "loading": "Loading your company profile",
      "loadError": "Could not load your company profile",
      "emptyTitle": "Your company profile is not ready yet",
      "emptyDescription": "Finish setup and Raldo fills this sheet in.",
      "editLinksAction": "Edit your links"
    },
    "customer": {
      "loading": "Loading your customer profile",
      "loadError": "Could not load your customer profile",
      "emptyTitle": "No customer profile yet",
      "emptyDescription": "Raldo writes it during setup. It is not here yet."
    },
    "publishing": {
      "title": "Publishing",
      "helper": "The author signs every page, and the trial page is where a page sends a reader who is ready.",
      "notSet": "Not set yet",
      "notSetAction": "Click to add",
      "urlError": "Enter a web address, like raldo.ai/trial.",
      "fields": {
        "name": {
          "label": "Author name",
          "hint": "Signs every page.",
          "editTitle": "Edit author name",
          "placeholder": "Dana Whitfield"
        },
        "role": {
          "label": "Role",
          "hint": "Shown under the name.",
          "editTitle": "Edit role",
          "placeholder": "Head of Growth"
        },
        "bio": {
          "label": "One-line bio",
          "hint": "A single line about who they are.",
          "editTitle": "Edit one-line bio",
          "placeholder": "Writes about shipping software without the drama."
        },
        "profileUrl": {
          "label": "Profile URL",
          "hint": "Where a reader finds the author.",
          "editTitle": "Edit profile URL",
          "placeholder": "linkedin.com/in/dana-whitfield"
        },
        "trialUrl": {
          "label": "Trial or demo page",
          "hint": "Where a page sends a reader who is ready.",
          "editTitle": "Edit trial or demo page",
          "placeholder": "raldo.ai/trial"
        }
      }
    }
  },
  "media": {
    "formatSquare": "Square (1:1)",
    "designOfPost": "Post · {title}",
    "freeDesign": "Free design",
    "formatPortrait": "Portrait (4:5)",
    "formatStory": "Story (9:16)",
    "uploads": "Uploads",
    "designs": "Designs",
    "newDesignTitle": "New design",
    "newDesignDescription": "Pick a format and start on a blank canvas.",
    "newUploadTitle": "Upload media",
    "newUploadDescription": "Bring in images from your device.",
    "templates": "Templates",
    "templatesEmptyTitle": "No brand style yet",
    "templatesEmptyDescription": "Open a design and choose Make brand style to turn it into the 16 layouts your brand uses.",
    "upload": "Upload",
    "create": "Create",
    "typeAriaLabel": "Media type",
    "loading": "Loading your media library",
    "loadError": "Could not load your media library",
    "emptyTitle": "Your media library is empty",
    "emptyDescription": "Uploaded images and saved templates will collect here.",
    "designsLoading": "Loading your designs",
    "designsLoadError": "Could not load your designs",
    "designsEmptyTitle": "No designs yet",
    "designsEmptyDescription": "Raldo makes designs in chat - ask for one there and it will show up here.",
    "designsEmptyAction": "Open chat",
    "deleteUploadTitle": "Delete {filename}?",
    "deleteUploadBody": "This removes the file from your library for good.",
    "deleteDesignTitle": "Delete {name}?",
    "deleteDesignBody": "This removes the design and its pages for good.",
    "createFromTemplateTitle": "Create a design from \"{name}\"?",
    "createFromTemplateBody": "This adds a new design to your brand, starting from this template.",
    "createDesignCta": "Create design",
    "draftingToast": "Raldo is drafting your post.",
    "untitledDesignName": "Untitled design",
    "toast": {
      "createDesignFailed": "Could not create this design",
      "renameDesignFailed": "Could not rename this design",
      "duplicateDesignFailed": "Could not duplicate this design",
      "deleteDesignFailed": "Could not delete this design",
      "saveDesignFailed": "Could not save this design",
      "uploadFailed": "Could not upload this file",
      "deleteFileFailed": "Could not delete this file"
    },
    "uploadError": {
      "contentTypeNotAllowed": "This file type is not supported. Upload a JPEG, PNG, GIF or WebP image.",
      "fileTooLarge": "This file is too large. The maximum size is 8MB.",
      "storageQuotaExceeded": "This brand has reached its storage limit.",
      "unreadableImage": "We couldn't read this image. Try a different file.",
      "uploadNotFound": "This upload could not be found. Try uploading again.",
      "fallback": "Something went wrong uploading this file. Try again."
    },
    "quickLook": {
      "dimensions": "Dimensions",
      "pixels": "{width} x {height} px",
      "size": "File size",
      "type": "Type",
      "added": "Added",
      "useInDesign": "Use in a design"
    },
    "brandStyle": {
      "title": "Brand style",
      "inUse": "In use",
      "fromDesign": "From {design}",
      "newTitle": "New brand style",
      "building": "Building the 16 layouts · {done} of {total}",
      "ready": "Ready to review",
      "loading": "Loading your brand style",
      "loadError": "Could not load your brand style"
    },
    "designMaking": "Raldo is making this design",
    "designMakingTitle": "Still making this design",
    "designMakingBody": "Raldo is still making this design. You can open it when it is ready. You get a message in your Inbox.",
    "designMakingConfirm": "Got it"
  },
  "content": {
    "status": {
      "draft": "Draft",
      "pendingHandoff": "Awaiting artwork",
      "scheduled": "Scheduled",
      "published": "Published",
      "failed": "Failed",
      "pendingHandoffCaption": "Waiting for artwork before this goes out."
    },
    "seeFullPost": "See full post",
    "minimize": "Minimize",
    "setDateTime": "Set date & time",
    "notScheduled": "Not scheduled",
    "noDateYet": "No date yet",
    "untitledPost": "Untitled post",
    "schedule": "Schedule",
    "reschedule": "Reschedule",
    "unschedule": "Unschedule",
    "cancel": "Cancel",
    "publishNow": "Publish now",
    "duplicate": "Duplicate",
    "tryAgain": "Try again",
    "correct": "Correct",
    "removeAttachment": "Remove",
    "replace": "Replace",
    "openOnLinkedIn": "Open on LinkedIn",
    "actionForTitleAria": "{action}: {title}",
    "canvasLabel": "Canvas",
    "createDesign": "Create design",
    "templateBadge": "Template",
    "brandBadge": "Brand",
    "editAttachment": "Edit attachment",
    "resultsLabel": "Results",
    "copyLabel": "Copy",
    "writePostCopyPlaceholder": "Write the post copy…",
    "frame": {
      "selectAria": "Select {title}",
      "plannedDateAria": "Set the planned date and time"
    },
    "peek": {
      "closeDetails": "Close details",
      "editCopyAria": "Edit copy for {title}"
    },
    "write": {
      "saving": "Saving…",
      "saved": "Saved",
      "scheduleEmptyHint": "Write something before scheduling this post.",
      "schedule": {
        "nextSlot": "Next open slot: {date}",
        "noCadence": "This brand has no posting cadence set yet, so Raldo can't suggest a slot.",
        "noOpenSlot": "Every slot in the posting cadence is already taken.",
        "pickAnotherDate": "Pick another date",
        "loadingAria": "Finding the next open slot"
      },
      "readability": {
        "tooltip": {
          "title": "Readability scale",
          "veryEasy": "9-10 · very easy - children's books",
          "easy": "7-8 · easy - fiction, strong marketing copy",
          "standard": "5-6 · standard - newspapers",
          "dense": "3-4 · dense - official documents",
          "difficult": "1-2 · difficult - academic",
          "footnote": "About 1 in 5 adults read at the lowest literacy level. Copy at 6/10 or higher stays readable for nearly everyone."
        }
      }
    },
    "post": {
      "unscheduled": "Unscheduled",
      "mediaLabel": "Media",
      "noMediaAttached": "No media attached",
      "askPlaceholder": "Ask Raldo to change this post…",
      "attachDesign": "Attach a design",
      "designHint": "Raldo can design the media from the post's slides, or you can attach a design you already have.",
      "openDesign": "Open design",
      "designMedia": "Design the media",
      "designMediaFailed": "Could not start the design",
      "designMediaRefused": {
        "noMedia": "This post has no slides to design yet.",
        "notDesignable": "Only a draft or a failed post without a design can get a new one.",
        "running": "Raldo is already making this post's design.",
        "editorRole": "Only an editor can design the media."
      },
      "run": {
        "working": "Raldo is writing a post.",
        "stages": {
          "brief": "Raldo is choosing the argument, the topic and the points.",
          "write": "Raldo is writing the caption and the slides.",
          "check": "Raldo is checking the post."
        },
        "completed": "The post is written.",
        "partial": "The post is written, but a step did not finish.",
        "cancelled": "You stopped the post.",
        "failed": "The post stopped"
      },
      "slides": "Slides",
      "slide": "Slide {n}",
      "score": "Score {score} of 100",
      "needsPerson": "Needs a person",
      "ready": "Ready",
      "readability": "Readability",
      "fromPage": "From the page",
      "madeFrom": "Made from",
      "addDesign": "Add a design",
      "editDesign": "Edit design",
      "viewDesign": "View design",
      "letRaldoDesign": "Let Raldo design it",
      "needsSlides": "Needs slides. This post has none yet.",
      "start": {
        "title": "Start",
        "letRaldoWrite": "Let Raldo write it",
        "orWrite": "Or write it yourself. The post is saved on the first word.",
        "whichArgument": "Which argument should the post make?",
        "letRaldoChoose": "Let Raldo choose",
        "fromBeliefMap": "From your belief map and research"
      }
    },
    "artwork": {
      "groupAria": "Post artwork",
      "loading": "Loading artwork",
      "loadError": "This page could not be loaded",
      "pageAlt": "Page {page}",
      "previousPage": "Previous page",
      "nextPage": "Next page",
      "goToPage": "Go to page {page}",
      "pageStatus": "Page {page} of {count}"
    },
    "designPicker": {
      "title": "Attach a design",
      "description": "Pick a finished design to use as this post's artwork.",
      "loading": "Loading your designs",
      "emptyTitle": "No designs are ready yet",
      "emptyDescription": "Raldo makes designs in chat - ask for one and it will show up here once it's ready."
    },
    "workspace": {
      "defaultAuthorName": "Your brand",
      "linkedinPublicMeta": "LinkedIn · Public",
      "weekOf": "Week of {date}",
      "unscheduledColumn": "Unscheduled",
      "scheduleReadyCount": "Schedule 1 post | Schedule {count} posts",
      "canvasEmptyTitle": "Nothing to review yet",
      "canvasEmptyDescription": "Once there are drafts or scheduled posts, they show up here to review side by side.",
      "untitledArticle": "Untitled page",
      "articlePlanning": "Raldo is planning this page…",
      "articleWriting": "Raldo is writing this page…",
      "scheduleGenerating": "Raldo is writing…"
    },
    "previousPeriod": "Previous period",
    "nextPeriod": "Next period",
    "calendar": {
      "week": "Week",
      "month": "Month",
      "today": "Today",
      "viewAria": "Calendar view",
      "articlesLane": "Pages",
      "articleBadge": "Page",
      "articleOpen": "Open the page",
      "articleQuestion": "Answers · {question}",
      "articleTopic": "Topic · {name}",
      "articleWords": "1 word | {count} words",
      "articleSections": "1 section | {count} sections",
      "articleStats": "{words} · {sections}",
      "kindAll": "All",
      "kindArticles": "Pages",
      "kindPosts": "Posts",
      "kindAria": "Filter by kind"
    },
    "metrics": {
      "clicks": "Clicks",
      "engagement": "Engagement"
    },
    "results": {
      "noneYet": "Nothing has been recorded yet.",
      "notLive": "Results show here once the post is live on LinkedIn."
    },
    "deleteAssetAria": "Delete asset",
    "postMediaAria": "Post media",
    "preview": {
      "mediaError": "Couldn't load this artwork",
      "croppedByFeed": "The feed will crop this artwork",
      "device": {
        "ariaLabel": "Preview device",
        "desktop": "Desktop",
        "tablet": "Tablet",
        "mobile": "Mobile"
      }
    },
    "loadingPlan": "Loading your content plan",
    "loadPlanError": "Could not load your content plan",
    "talkToRaldo": "Talk to Raldo",
    "deleteDialog": {
      "title": "Delete this post?",
      "description": "This deletes the post and its revision history for good. This cannot be undone."
    },
    "publishDialog": {
      "title": "Publish this post now?",
      "description": "This publishes the post to LinkedIn right now and cannot be undone through Raldo. The only way back is to delete it, which destroys the post and any engagement it has received."
    },
    "scheduleReadyDialog": {
      "title": "Schedule everything ready?",
      "description": "This schedules 1 post for publishing. | This schedules {count} posts for publishing."
    },
    "removeArtworkDialog": {
      "title": "Remove this artwork?",
      "description": "The post keeps its copy and schedule; the design itself is not deleted."
    },
    "toast": {
      "saveEditFailed": "Could not save this edit",
      "restoreFailed": "Could not restore this version",
      "scheduleFailed": "Could not schedule this post",
      "publishFailed": "Could not publish this post",
      "rescheduleFailed": "Could not reschedule this post",
      "setPublishAtFailed": "Could not move this post's date",
      "cancelScheduleFailed": "Could not cancel this schedule",
      "deleteFailed": "Could not delete this post",
      "schedulePeriodFailed": "Could not schedule these posts",
      "createFailed": "Could not create this post",
      "attachDesignFailed": "Could not attach this design",
      "nextSlotFailed": "Could not find the next open slot",
      "editArticleMetaFailed": "Could not save this edit",
      "attachPublishedUrlFailed": "Could not save this address",
      "promoteArticleFailed": "Could not promote this page",
      "promoteArticleNotVerified": "This page's address has not verified yet. It can be promoted once its live URL is confirmed.",
      "recheckArticleHealthFailed": "Could not check the live page",
      "exportArticleFailed": "Could not export this page",
      "writePostFailed": "Could not start the post"
    },
    "renderGate": {
      "preparing": "Preparing artwork for \"{post}\" - {current} of {total}",
      "preparingBulk": "Preparing artwork - {current} of {total} posts",
      "failedTitle": "Couldn't prepare artwork",
      "failedDescription": "\"{post}\"'s design couldn't be rendered. Try again.",
      "missingRenderMessage": "This post's artwork wasn't ready. Try again and Raldo will prepare it first."
    },
    "draftConflict": {
      "message": "Raldo rewrote this post. You have unsaved changes here - choose which version to keep.",
      "compare": "Compare",
      "hideCompare": "Hide comparison",
      "keepMine": "Keep mine",
      "useRaldos": "Use Raldo's"
    },
    "shapeFilter": {
      "all": "All",
      "posts": "Posts",
      "articles": "Pages",
      "aria": "Filter by shape"
    },
    "create": {
      "button": "Create content",
      "page": {
        "title": "Which page should it write?",
        "description": "Pick a planned page. Raldo drafts the text that answers its question.",
        "confirm": "Write it",
        "label": "Page",
        "placeholder": "Search your planned pages",
        "next": "Next",
        "emptyTitle": "No page left to write",
        "emptyBody": "Every planned page has a draft, or the plan has not run yet."
      },
      "newPost": "New post",
      "newPage": "New page"
    },
    "topics": {
      "removeTitle": "Remove this topic?",
      "removeBody": "This removes the topic for good.",
      "add": "Add a topic",
      "covers": "What it covers",
      "remove": "Remove topic",
      "untitled": "Untitled topic",
      "newTopic": "New topic",
      "editTitle": "Edit topic"
    },
    "keywords": {
      "cells": {
        "notMeasured": "Not measured",
        "notRanking": "Not ranking"
      }
    },
    "inspector": {
      "reasons": {
        "link": "Has a link",
        "unsupportedFigure": "A number has no source",
        "hookLength": "Hook is too long",
        "bodyLength": "Body is too long",
        "captionLength": "Post is too long",
        "ctaLines": "Call to action runs past one line",
        "slideLayout": "Slide layout is off",
        "slideTextLength": "Slide text is too long",
        "slideParts": "A slide has the wrong parts",
        "slideFigure": "A slide number is wrong",
        "slideQuote": "A quote does not match its source",
        "slideHighlight": "A highlight is wrong",
        "slideImages": "Too many image ideas",
        "avoidedWord": "Uses a word to avoid",
        "termForm": "A name is written wrong",
        "aiTell": "Reads like AI wrote it",
        "bannedStructure": "Uses a banned phrasing",
        "markdown": "Has markdown symbols",
        "hashtags": "Wrong number of hashtags",
        "proof": "No proof for the claim",
        "phase": "Wrong buyer stage",
        "beliefLink": "Does not argue the point",
        "generic": "Raldo flagged a rule"
      },
      "beforePublish": "Before you publish",
      "history": "History",
      "argues": "Argues",
      "stage": "Stage · {name}",
      "topic": "Topic",
      "standsOn": "Stands on",
      "sources": "{count} source | {count} sources",
      "asksReaders": "Asks readers to",
      "changedAfterCheck": "You changed the text after Raldo's check.",
      "notChecked": "Raldo has not checked this post.",
      "argument": "Argument",
      "argumentLine": "The argument this post makes.",
      "claim": "Claim",
      "openArgument": "Open the argument",
      "standsOnLine": "The facts in the post and who said them.",
      "cta": {
        "toMedia": "See the slides",
        "comment": "Comment",
        "save": "Save the post",
        "article": "Read the article",
        "demo": "Book a demo"
      },
      "bar": {
        "words": "{count} words",
        "hashtags": "{count} hashtags",
        "characters": "{count} / {limit} characters",
        "readability": "Readability {score}/10",
        "lengthAria": "About the length",
        "lengthTitle": "Length",
        "lengthOptimal": "Optimum about {count} words for {channel}",
        "lengthVisible": "The first {count} characters show before \"see more\"",
        "lengthNote": "A guide, not a limit."
      },
      "brief": "Brief"
    },
    "newPost": "New post"
  },
  "strategy": {
    "keyword": {
      "standing": {
        "page1": "Page 1 of Google · #{rank}",
        "below": "Below page 1 of Google · #{rank}",
        "rank": "#{rank}",
        "notRanking": "Not ranking in Google"
      },
      "figures": {
        "searches": "Searches a month",
        "onGoogle": "On Google",
        "notMeasured": "Not measured yet",
        "competition": "Difficulty",
        "competitionScore": "{score} out of 100",
        "firstRank": "#{rank} on {date}",
        "rank": "Your rank on Google",
        "page1": "Page 1",
        "below": "Below page 1",
        "notRankingYet": "Not ranking yet",
        "ai": "Google AI Overview",
        "notChecked": "Not checked yet",
        "noAnswer": "There is no AI answer for it",
        "rivalCited": "A rival is cited",
        "citesOthers": "The answer cites others",
        "rivalsToo": "A rival is cited too | {count} rivals are cited too",
        "noRival": "And no rival",
        "cited": "Cited",
        "notCited": "Not cited"
      },
      "stats": {
        "published": "published",
        "drafting": "drafting",
        "noContent": "with no content yet",
        "page1": "on page 1",
        "below": "below page 1",
        "rankRest": "not ranking or not measured yet",
        "citeYou": "cite you",
        "withoutYou": "answer without you",
        "aiRest": "with no AI answer",
        "covered": "Keywords you have content for",
        "ranking": "Keywords where you rank on page 1 of Google",
        "cited": "Keywords where AI answers cite you"
      },
      "citations": {
        "cited": "Cited",
        "notCited": "Not cited",
        "columns": {
          "site": "Site",
          "answer": "In the answer"
        }
      },
      "rankHistory": {
        "aria": "Search rank over the last {count} weeks, from #{from} to #{to}",
        "threshold": "Page 1"
      },
      "difficultyScore": {
        "low": "Low difficulty, {score} out of 100",
        "medium": "Medium difficulty, {score} out of 100",
        "high": "High difficulty, {score} out of 100"
      },
      "difficulty": {
        "low": "Low",
        "medium": "Medium",
        "high": "High"
      },
      "rankings": {
        "visits": "{visits} visit/mo | {visits} visits/mo",
        "none": "Neither you nor a tracked rival ranks for it.",
        "columns": {
          "rank": "Rank",
          "site": "Site",
          "page": "Page that ranks",
          "visits": "Visits a month"
        }
      },
      "volumeHistory": {
        "aria": "Searches a month, {from} to {to}: from {first} to {last}"
      },
      "site": {
        "you": "You"
      }
    },
    "keywords": {
      "columns": {
        "keyword": "Keyword",
        "stage": "Stage",
        "volume": "Volume/mo",
        "difficulty": "Difficulty",
        "searchRank": "Search rank",
        "aiOverview": "Cited in AI Overview"
      }
    },
    "schedule": {
      "days": "Days",
      "off": "Off",
      "maxDays": "{count} days a week at most",
      "unsavedChanges": "Your posting schedule has unsaved changes."
    },
    "coreMessage": {
      "caption": "Your core message",
      "editTitle": "Edit core message"
    },
    "argument": {
      "open": "Open argument: {subject}"
    },
    "noContent": "No content yet",
    "pieces": {
      "count": "{count} pieces of content | {count} piece of content | {count} pieces of content",
      "list": "{title}: {count} pieces of content | {title}: {count} piece of content | {title}: {count} pieces of content",
      "seeAll": "See all {count} pieces of content",
      "seeAllCount": "See all {count}",
      "linkedinPost": "LinkedIn post",
      "published": "Published {date}",
      "scheduled": "Scheduled for {date}",
      "draft": "Draft"
    },
    "journeyStage": "Journey stage",
    "addArgument": "Add argument",
    "balance": {
      "caption": "Content distribution by buyer's journey stage",
      "window": "Last 90 days",
      "aria": "Share of content per journey stage"
    },
    "argumentPage": {
      "editTitle": "Edit argument",
      "crumb": "{stage} argument",
      "back": "Back to Strategy",
      "remove": "Remove argument",
      "removeTitle": "Remove this argument?",
      "removeBody": "This removes the argument for good.",
      "content": "Content",
      "posts": "{count} posts | {count} post | {count} posts",
      "articles": "{count} pages | {count} page | {count} pages",
      "postsAndArticles": "{posts} and {articles}",
      "groups": {
        "published": "Published",
        "scheduled": "Scheduled",
        "drafts": "Drafts"
      },
      "noContentTitle": "No content argues this yet",
      "noContentBody": "Plan a page or a post, and Raldo drafts it from this argument."
    },
    "topicPage": {
      "distributionAria": "Share of this topic's content per journey stage",
      "stageArguments": "Arguments at the {stage} stage",
      "argumentCount": "{count} arguments | {count} argument | {count} arguments",
      "noneCarried": "No arguments carried yet",
      "nothingAtStage": "Nothing in this topic argues at the {stage} stage yet.",
      "piecesInTopic": "{count} pieces of content in this topic | {count} piece of content in this topic | {count} pieces of content in this topic",
      "notFoundTitle": "That topic does not exist",
      "notFoundBody": "It may have been deleted, or the link may be wrong.",
      "missing": "This topic no longer exists.",
      "tabsAria": "Topic sections"
    },
    "pages": {
      "groups": {
        "explainer": "Explainer",
        "offer": "Product pages",
        "comparison": "Comparison pages",
        "use-case": "Use case pages",
        "supporting": "Supporting pages"
      },
      "types": {
        "explainer": "Explainer",
        "offer": "Product page",
        "comparison": "Comparison page",
        "use-case": "Use case page",
        "supporting": "Supporting page"
      }
    },
    "citations": {
      "none": "None",
      "ownCited": "You, cited",
      "ownNamed": "Names you, no link",
      "rivalCited": "{name}, cited"
    },
    "stageField": {
      "notPlaced": "Not placed in a stage yet",
      "notPlacedHint": "Edit it to choose the stage."
    },
    "plan": {
      "start": "Plan pages",
      "emptyTitle": "No plan yet",
      "emptyBody": "Raldo lists every page on your site and checks how each one ranks.",
      "stale": {
        "title": "The strategy changed after this plan was made",
        "body": "Plan the pages again so the plan follows your current strategy."
      },
      "proposal": {
        "summary": {
          "nothing": "The new plan changes nothing in your current plan.",
          "pagesAdded": "{count} page added | {count} pages added",
          "pagesRemoved": "{count} page removed | {count} pages removed",
          "pagesChanged": "{count} page changed | {count} pages changed",
          "pagesKept": "{count} written page kept | {count} written pages kept",
          "topicsAdded": "{count} topic added | {count} topics added",
          "topicsRemoved": "{count} topic removed | {count} topics removed",
          "topicsRenamed": "{count} topic renamed | {count} topics renamed"
        },
        "accept": "Accept",
        "startBlocked": "Accept or discard the new plan first.",
        "discardConfirm": {
          "title": "Discard the new plan?",
          "body": "Your current plan stays as it is. You can plan the pages again later."
        },
        "refusals": {
          "ownerAdminRequired": "Only an owner or admin can change the plan.",
          "gateMissing": "This step is no longer waiting for you.",
          "answerInvalid": "The topics you kept no longer match the proposal. Reload and try again."
        }
      },
      "run": {
        "working": "Raldo is planning your pages.",
        "waiting": "The new plan waits for your review.",
        "stages": {
          "inventory": "Raldo is listing the pages on your site.",
          "content": "Raldo is reading your pages.",
          "research": "Raldo is finding the names your buyers use.",
          "competitors": "Raldo is reading what your competitors rank for.",
          "demand": "Raldo is measuring how often each term is searched.",
          "relevance": "Raldo is scoring the searches for your company.",
          "topic-candidates": "Raldo is proposing the topics.",
          "review-topics": "The topics wait for your review.",
          "fill": "Raldo is researching the topic you added.",
          "serp": "Raldo is reading the search results for each search.",
          "grouping": "Raldo is grouping the searches into pages.",
          "type-stage": "Raldo is deciding what each page is for.",
          "placement": "Raldo is placing each page under a topic.",
          "decision-pages": "Raldo is adding the pages buyers read before they choose.",
          "site-match": "Raldo is matching the plan with the pages on your site.",
          "review-plan": "The plan waits for your review.",
          "commit": "Raldo is writing the plan."
        },
        "completed": "The plan is ready.",
        "partial": "The plan is ready, but some steps did not finish.",
        "cancelled": "You cancelled the plan.",
        "failed": "The plan stopped",
        "startDescription": "Raldo plans your topics first, then the pages. You review both.",
        "direction": "Direction",
        "directionHint": "One line Raldo keeps in mind while it plans.",
        "directionPlaceholder": "For example: focus on answer engines",
        "market": "Market",
        "planWithDirection": "Plan with a direction"
      },
      "figures": {
        "notMeasured": "Not measured yet"
      },
      "topics": {
        "pages": "Pages",
        "writingOrder": "In writing order",
        "pageCount": "{count} page | {count} pages",
        "progress": "{count} of {total} pages written, live or on your site",
        "pagesDone": "{count} of {total} pages",
        "statusCounts": {
          "planned": "{count} planned",
          "writing": "{count} writing",
          "live": "{count} live",
          "site": "{count} on your site"
        }
      },
      "page": {
        "hub": "Hub page",
        "searchesAMonth": "{volume} searches a month",
        "writeNext": "Write next",
        "comparesWith": "Compares with {name}",
        "searches": "Searches it answers",
        "columns": {
          "search": "Search",
          "role": "Role",
          "volume": "Searches a month"
        },
        "roles": {
          "main": "Main",
          "secondary": "Secondary"
        },
        "updates": "Updates a page on your site",
        "noArticleTitle": "No draft yet",
        "noArticleBody": "Raldo drafts the text that answers this question, from your arguments and sources.",
        "notFoundTitle": "That page does not exist",
        "notFoundBody": "It may have been deleted, or the link may be wrong.",
        "write": "Write page",
        "run": {
          "working": "Raldo is writing this page.",
          "stages": {
            "sources": "Raldo is reading the pages that rank for this question.",
            "scope": "Raldo is sorting what the pages say into the subjects of this page.",
            "trace": "Raldo is tracing each fact to its original source.",
            "evidence": "Raldo is reading your own pages for what you can show first hand.",
            "gain": "Raldo is finding what this page can add.",
            "argument": "Raldo is choosing the argument of this page.",
            "plan": "Raldo is planning the page.",
            "draft": "Raldo is drafting the page.",
            "edit": "Raldo is editing the page.",
            "check": "Raldo is checking the page.",
            "handoff": "Raldo is preparing the page for your site."
          },
          "completed": "The page is written.",
          "partial": "The page is written, but some steps did not finish.",
          "cancelled": "You cancelled the page.",
          "failed": "The page stopped",
          "waiting": "Raldo has questions for you. Answer or skip them and the page goes on."
        },
        "research": {
          "title": "Research",
          "sources": "{read} of {found} pages read",
          "statements": "statements the pages make",
          "items": "{items} subjects",
          "points": "points, format {format}",
          "noFormat": "not set",
          "facts": "{facts} facts",
          "traced": "traced to their source, {waiting} waiting",
          "ownPages": "{pages} of your own pages",
          "evidence": "pieces of evidence, {items} subjects with some"
        },
        "argumentCarriedBy": "Carried by {item}",
        "gains": {
          "kinds": {
            "disagreement": "Sources disagree",
            "gap": "Gap",
            "ai-answers": "AI answers",
            "brand": "From you"
          }
        },
        "questions": {
          "title": "Questions for you",
          "open": "{count} open | {count} open",
          "hint": "What helps: {hint}",
          "without": "Without it: {without}",
          "placeholder": "Type in your answer here",
          "answer": "Answer",
          "skip": "Skip",
          "skipped": "Skipped"
        },
        "hubOf": "Hub of {topic}",
        "fault": {
          "title": "Raldo could not read the live page",
          "body": "Raldo checked {address} on {date}. The page counts as live once a check passes.",
          "bodyUndated": "Raldo checked {address}. The page counts as live once a check passes."
        },
        "noArticleRunning": "Raldo drafts it when the research is done.",
        "noArticleSite": "This page is already on your site.",
        "noSearchesTitle": "No searches for this page",
        "noSearchesBody": "This page carries an argument, not a search. Its reach shows in Visibility, AI answers."
      },
      "status": {
        "planned": "Planned",
        "writing": "Writing",
        "live": "Live",
        "site": "On your site"
      },
      "argument": {
        "underTopic": "Argued under the topic",
        "pages": "Pages that argue it",
        "pageCount": "{count} page | {count} pages"
      },
      "overview": {
        "pagesByStage": "{count} page | {count} pages",
        "caption": "Planned pages by buyer's journey stage",
        "ariaLabel": "Share of planned pages per journey stage"
      },
      "setup": {
        "title": "Your plan",
        "startsWith": "Starts with: {question}"
      },
      "stops": {
        "aria": "Steps of the plan run",
        "titles": {
          "find-topics": "Find topics",
          "review-topics": "Review topics",
          "plan-pages": "Plan pages",
          "review-plan": "Review plan"
        },
        "stepOf": "Step {n} of {total}",
        "done": "Done",
        "waitsForYou": "Waits for you",
        "yourReview": "Your review",
        "steps": "{count} step | {count} steps"
      },
      "step": {
        "titles": {
          "inventory": "Site pages",
          "content": "Page content",
          "research": "Research",
          "competitors": "Competitors",
          "demand": "Demand",
          "relevance": "Relevance",
          "topic-candidates": "Topic candidates",
          "review-topics": "Review topics",
          "fill": "Fill new topics",
          "serp": "Search results",
          "grouping": "Pages",
          "type-stage": "Page types",
          "placement": "Placement",
          "decision-pages": "Decision pages",
          "site-match": "Site match",
          "review-plan": "Review plan",
          "commit": "Write the plan"
        },
        "summaries": {
          "inventory": "{count} page on your site | {count} pages on your site",
          "content": "{count} page read | {count} pages read",
          "research": "{terms} terms for {coverage} coverage items",
          "competitors": "{competitors} competitors · {searches} searches",
          "demand": "{count} search measured | {count} searches measured",
          "relevance": "{kept} of {units} searches kept",
          "topic-candidates": "{count} topic proposed | {count} topics proposed",
          "review-topics": "{count} topic approved | {count} topics approved",
          "fill": "No topic to research | {count} topic researched | {count} topics researched",
          "serp": "{count} search read | {count} searches read",
          "grouping": "{pages} pages from {keywords} searches",
          "type-stage": "{kept} of {pages} pages kept",
          "placement": "{pages} pages under {topics} topics",
          "decision-pages": "{count} decision page | {count} decision pages",
          "site-match": "{planned} pages · {update} update a page on your site",
          "review-plan": "No page removed | {count} page removed | {count} pages removed",
          "commit": "{pages} pages in {topics} topics"
        },
        "counts": {
          "keywords": "Searches",
          "ordered": "Searches asked for",
          "received": "Results received",
          "missing": "Results missing",
          "clusters": "Groups",
          "pages": "Pages",
          "topics": "Topics",
          "dropped": "Topics left out",
          "objectives": "Arguments",
          "planned": "Planned pages",
          "existing": "Pages on your site",
          "excluded": "Pages left out",
          "byRanking": "Matched by ranking",
          "byModel": "Matched by reading",
          "update": "Pages to update"
        },
        "finished": "Finished {time}",
        "durationSeconds": "{count} s",
        "durationMinutes": "{count} min",
        "back": "Back to the run",
        "rerun": "Rerun from here",
        "rerunBlocked": "Wait until the run stops at a review, then rerun.",
        "rerunConfirm": {
          "title": "Rerun from {step}?",
          "body": "The steps before it keep their outputs. Raldo runs the rest again and stops at your reviews.",
          "confirm": "Rerun"
        },
        "coverage": "Coverage",
        "coverageMeta": "What Raldo searched for",
        "terms": "Terms",
        "kept": "Kept",
        "dropped": "Dropped",
        "removedByYou": "Removed by you",
        "editsNote": "Your changes are saved beside Raldo's output. Raldo can show both.",
        "score": "{score} of 5",
        "notScored": "Not scored yet",
        "columns": {
          "term": "Term",
          "coverage": "Coverage item",
          "search": "Search",
          "volume": "Searches a month",
          "score": "Relevance",
          "kept": "Kept",
          "reason": "Why",
          "actions": "Actions"
        },
        "research": {
          "figures": {
            "coverage": "Coverage items",
            "terms": "Terms found",
            "kept": "Kept by relevance",
            "changed": "Changed by you"
          },
          "termCount": "{count} term | {count} terms",
          "addTerm": "Add a term",
          "termPlaceholder": "Name the term",
          "notPlaced": "Not placed yet"
        },
        "competitors": {
          "caption": "{searches} search · {website} | {searches} searches · {website}"
        },
        "demand": {
          "figures": {
            "measured": "Searches measured",
            "units": "Searches found"
          },
          "measuredOf": "{measured} of {terms} measured"
        },
        "relevance": {
          "figures": {
            "kept": "Searches kept",
            "dropped": "Searches dropped"
          }
        }
      },
      "review": {
        "topicsTitle": "Review the topics",
        "topicsBody": "Raldo proposes {count} topic. Keep it, rename it or add your own, then let Raldo plan the pages. | Raldo proposes {count} topics. Keep the ones you want to own, rename or remove the rest, add your own, then let Raldo plan the pages.",
        "topicCounts": "Approved: {kept} · Removed: {removed}",
        "keepOne": "Keep at least one topic.",
        "addTopic": "Add a topic",
        "namePlaceholder": "Name the topic",
        "add": "Add",
        "rename": "Rename",
        "remove": "Remove",
        "keep": "Keep",
        "removed": "Removed",
        "renamed": "Renamed",
        "moveUp": "Move up",
        "moveDown": "Move down",
        "addedByYou": "Added by you",
        "addedCaption": "Raldo researches this topic when it plans the pages.",
        "argues": "Argues {names}",
        "difficulty": {
          "easy": "Easy for your site",
          "medium": "Takes some work",
          "hard": "Hard for your site"
        },
        "topicsNote": "Raldo plans pages for the approved topics only. It researches the topics you added first.",
        "planTitle": "Review the plan",
        "planHint": "Open a topic, remove a page you do not want, then accept the plan.",
        "hub": "Hub: {question}",
        "decisionPage": "Decision page"
      }
    },
    "research": {
      "title": "Research",
      "emptyTitle": "No research yet",
      "emptyBody": "Write a page of this topic and Raldo traces every fact it uses to its original source.",
      "readyAndWaiting": "{ready} ready · {waiting} waiting for a source",
      "entryCount": "{count} entry | {count} entries",
      "usedBy": "Used by {count} page | Used by {count} pages",
      "notUsed": "Not used yet",
      "foundOn": "Found on {pages}",
      "waitingTitle": "Waiting for a source",
      "waitingCount": "{count} item | {count} items",
      "waitingNote": "A run found these but could not reach an original source. They are not ready to use.",
      "columns": {
        "research": "Research",
        "foundOn": "Found on",
        "why": "Why it waits"
      },
      "forPage": "For {page}",
      "statesItAs": "{source} states it as",
      "checked": "Checked {date}",
      "checkAgain": "Check again",
      "dueForCheck": "{count} entry last checked over {days} days ago | {count} entries last checked over {days} days ago",
      "checkedToast": "Checked {count} entry | Checked {count} entries",
      "changedCount": "{count} changed",
      "failedCount": "Could not check {count}",
      "failedToast": "Could not check {count} entry | Could not check {count} entries",
      "nothingDue": "No entry was due for a check",
      "retrievedFrom": "Retrieved from",
      "originalSource": "Original source",
      "foundOnSource": "Found on: {title}",
      "relevantTo": "Relevant to",
      "outlineItem": "Outline item “{item}”",
      "usedByTitle": "Used by",
      "sectionCount": "{count} section | {count} sections",
      "section": "Section “{heading}”",
      "noMatch": "No outline item matched it.",
      "noUse": "No page section lists it as a source yet.",
      "notFoundTitle": "That research entry does not exist",
      "notFoundBody": "It may have been replaced by a newer run, or the link may be wrong.",
      "trace": {
        "traced": "Traced by its link",
        "tracedBySearch": "Traced by search",
        "originNotReached": "Other pages repeat it. The original was not reached.",
        "originNotReachedNamed": "Other pages repeat it and name {source}. The original was not reached.",
        "doesNotStateIt": "The linked source does not say it.",
        "noSourceGiven": "No source given, and a search found none.",
        "sentenceNotVerified": "The source page does not state it word for word.",
        "notJudged": "The run reached its limit before judging it.",
        "originIsRival": "The origin is a ranking or rival page."
      },
      "quoted": "“{quote}”"
    },
    "addPage": {
      "action": "Add a page",
      "title": "Add a page",
      "description": "Raldo adds the page at the end of this topic's writing order. This can take up to two minutes.",
      "questionLabel": "Question",
      "questionPlaceholder": "What does the page answer?",
      "keywordLabel": "Keyword",
      "keywordHint": "Raldo measures how often people search for it.",
      "tooLong": "Use {max} characters or fewer.",
      "confirm": "Add page",
      "adding": "Adding the page",
      "refusals": {
        "editorRequired": "Your role can read this brand but cannot change it.",
        "pageExists": "The plan already has a page for this question or keyword.",
        "notFit": "Raldo could not fit this page into your plan. Try a different question."
      }
    },
    "findMorePages": {
      "action": "Find more pages",
      "needsPlan": "Make a plan first. Raldo adds the new pages to it."
    }
  },
  "article": {
    "document": {
      "askAboutPassage": "Ask Raldo"
    },
    "preview": {
      "heading": "How it will look in results",
      "titleLabel": "Result title",
      "summaryLabel": "Result summary",
      "hint": "Click either line to edit it.",
      "address": "… › {slug}",
      "addressWithDomain": "{domain} › {slug}",
      "cutHint": "Google cuts the tinted part.",
      "emptyTitle": "Add a title",
      "emptySummary": "Google writes its own summary when this is empty."
    },
    "todo": {
      "askRaldo": "Ask Raldo"
    },
    "details": {
      "todo": "To do",
      "links": {
        "missingLive": "Not on the live page",
        "missingLiveTitle": "The live page has no link to \"{title}\"",
        "missingLiveBody": "Raldo read {page} on {date}. The draft links to this page; the published copy does not. Republish the export.",
        "missingLiveBodyUndated": "Raldo read {page}. The draft links to this page; the published copy does not. Republish the export.",
        "checkAgain": "Check again"
      },
      "basedOn": {
        "nothing": "Nothing beyond the consensus."
      }
    },
    "panel": {
      "label": "Panel view",
      "content": "Content",
      "search": "Search",
      "sections": "Sections"
    },
    "status": {
      "draft": "Draft"
    },
    "header": {
      "publishedUrlPlaceholder": "https://yourdomain.com/blog/...",
      "publishedUrlError": "Enter a web address, like raldo.ai/blog/my-post.",
      "attachUrlConfirm": "Save",
      "openPublished": "Open the page",
      "markPublished": "Mark as published",
      "promote": "Promote to a post",
      "export": "Export",
      "exportNotReady": "Export once the page is written."
    },
    "inspector": {
      "groups": {
        "blockers": "Before you publish",
        "search": "Search overview"
      },
      "showMe": "Show me",
      "blockers": {
        "claims": "A sentence has no proof | {count} sentences have no proof",
        "termForm": "Names written wrong",
        "termFormCaption": "{spellings} · {count} place | {spellings} · {count} places",
        "readability": "Hard to read",
        "readabilityCaption": "Reading level {score}, the limit is {limit}",
        "placeholders": "Still to fill in"
      },
      "claims": {
        "text": "Nothing in your material supports these sentences.",
        "quote": "“{sentence}”"
      },
      "termForm": {
        "text": "A name must have its own spelling.",
        "hit": "\"{from}\" is written \"{to}\"",
        "places": "{count} place | {count} places"
      },
      "readability": {
        "hardestFirst": "Hardest first"
      },
      "placeholders": {
        "text": "These places in the text are still empty."
      },
      "metric": {
        "grade": "Reading grade {count}",
        "filler": "No filler words | {count} filler word | {count} filler words",
        "gain": "{count}% of the words add something new",
        "copies": "{count} sentence copies | {count} sentences copy",
        "noCopies": "No sentence copies",
        "companyOk": "All planned facts stated",
        "companyMissing": "A planned company fact is missing",
        "tablesOk": "No table without a source",
        "tablesMissing": "{count} table row without a source | {count} table rows without a source"
      },
      "basedOn": {
        "answers": "Your answers",
        "answersText": "What you told Raldo, and where the writer used it.",
        "yourAnswer": "Your answer",
        "brand": "Your brand",
        "brandText": "Facts from your brand that shaped the text.",
        "sources": "Sources cited",
        "sourcesText": "Each fact the text takes from another site.",
        "pages": "Pages the writer read",
        "pagesText": "The ranking pages Raldo read before it wrote. Not cited.",
        "pageSections": "{count} section | {count} sections",
        "adds": "What this page adds",
        "addsText": "What the ranking pages do not say."
      },
      "gain": {
        "ai-answers": "AI answers",
        "brand": "Your brand",
        "disagreement": "Disagreement"
      },
      "publishing": {
        "faq": "FAQ schema",
        "faqText": "The questions the CMS gets as structured data.",
        "links": "Links to your pages",
        "linksText": "Pages of the topic that this page links to, at their current address. A page that is not published yet goes live later.",
        "notLive": "Goes live later"
      }
    },
    "sources": {
      "title": "Sources"
    },
    "look": {
      "title": "Worth a look",
      "headingCase": "Title in Title Case",
      "headingCaseText": "Headings read better in sentence case.",
      "keywordHeading": "Keyword not in a heading",
      "keywordHeadingText": "No section heading carries the main keyword.",
      "rule": "Writing rule",
      "noNearCopy": {
        "title": "Copies a ranking page",
        "caption": "{count} sentence | {count} sentences",
        "text": "These sentences share a long run of words with a page that ranks.",
        "ask": "Ask Raldo to reword them",
        "askMessage": "Reword the sentences that copy ranking pages."
      },
      "noFiller": {
        "title": "Filler",
        "caption": "{count} section | {count} sections",
        "text": "Sentences that are there only to fill space."
      },
      "statesGain": {
        "title": "Says nothing new",
        "caption": "{count} section | {count} sections",
        "text": "The section says only what ranking pages already say."
      }
    },
    "top": {
      "words": "{count} word | {count} words",
      "faqs": "{count} FAQ | {count} FAQs",
      "links": "{count} link | {count} links"
    }
  },
  "notes": {
    "toast": {
      "addEntryFailed": "Could not add this entry",
      "saveEditFailed": "Could not save this edit",
      "deleteEntryFailed": "Could not delete this entry"
    },
    "deleteEntryTitle": "Delete this entry?",
    "deleteEntryBody": "This removes it from your notes. This cannot be undone from here.",
    "removeLink": "Remove link",
    "composerPlaceholder": "What should Raldo know?"
  },
  "insights": {
    "impressionsLabel": "Impressions",
    "reachLabel": "Reach"
  },
  "chat": {
    "untitledChat": "Untitled chat",
    "conversationLabel": "Conversation",
    "scrollToBottom": "Scroll to bottom",
    "backToWhereIWas": "Back to where I was",
    "removeContextItem": "Remove {label}",
    "context": {
      "passage": "“{text}”"
    },
    "closedThreadMessage": "This chat is closed. Start a new chat to keep going.",
    "deleteDialog": {
      "title": "Delete \"{name}\"?",
      "description": "This conversation and every message in it are deleted for good. This cannot be undone."
    },
    "errors": {
      "rateLimited": "You've hit the messaging rate limit. Please wait a moment and try again.",
      "notYours": "This conversation belongs to someone else.",
      "deleteFailed": "Could not delete this conversation",
      "loadThreadsFailed": "Could not load your conversations",
      "loadThreadFailed": "Could not load this conversation"
    },
    "dock": {
      "close": "Close chat",
      "label": "Contextual chat",
      "askRaldo": "Ask Raldo",
      "resize": "Resize the panel"
    },
    "composer": {
      "placeholder": "Type something",
      "send": "Send",
      "stop": "Stop",
      "attach": "Attach an image",
      "attachedImage": "Attached image",
      "removeImage": "Remove image",
      "uploadingImage": "Uploading image",
      "retry": "Try again",
      "tabKey": "Tab",
      "dropToAttach": "Drop to attach",
      "keyHint": "Enter sends · Shift and Enter adds a line"
    },
    "agentPulse": "Raldo is working",
    "badge": {
      "closed": "Closed"
    },
    "nav": {
      "chats": "Chats",
      "newChat": "New chat",
      "seeAll": "See all chats"
    },
    "archive": {
      "messageCount": "1 message | {count} messages",
      "actionsFor": "Actions for {title}"
    },
    "chatsView": {
      "loading": "Loading your conversations",
      "tryAgain": "Try again",
      "emptyTitle": "No conversations yet",
      "emptyDescription": "Every chat you start with Raldo is kept here, newest first.",
      "listAria": "Conversations",
      "showingRange": "Showing {start} to {end}",
      "previous": "Previous",
      "next": "Next"
    },
    "activity": {
      "thinking": "Thinking…",
      "webSearch": "Conducting web search…",
      "research": "Researching competitor…",
      "drafting": "Drafting brief…",
      "editing": "Editing copy…",
      "generating": "Generating…",
      "navigating": "Opening…",
      "failed": "failed",
      "notOpened": "Not opened",
      "inProgress": "in progress",
      "done": "done",
      "pending": "pending",
      "opener": "Thinking",
      "workedSummary": "Worked for {seconds}s · {count} step | Worked for {seconds}s · {count} steps",
      "workedSummaryUnknownDuration": "Worked · {count} step | Worked · {count} steps",
      "summaryWithFailures": "{summary} · {failed}",
      "failedCount": "{count} failed",
      "moreSources": "+{count} more",
      "searchingWebFor": "Searching the web for “{query}”",
      "searchGroup": "Searching the web · {count} search | Searching the web · {count} searches",
      "resultCount": "{count} result | {count} results",
      "searching": "Searching…",
      "label": {
        "fallback": {
          "thinking": "Thinking",
          "webSearch": "Searching the web",
          "research": "Looking something up",
          "drafting": "Drafting",
          "editing": "Making an update",
          "generating": "Generating",
          "navigating": "Opening a screen"
        },
        "question": {
          "asking": "Asking a question"
        },
        "documents": {
          "listing": "Checking available documents",
          "reading": "Reading a document"
        },
        "knowledge": {
          "listing": "Checking your knowledge",
          "readingPage": "Reading a knowledge page",
          "organizing": "Organizing your knowledge"
        },
        "inbox": {
          "checking": "Checking the inbox"
        },
        "memoryCandidate": {
          "noting": "Noting something to remember"
        },
        "memory": {
          "checking": "Checking brand memory",
          "readingPage": "Reading a memory page",
          "followingLink": "Following a memory link"
        },
        "socialConnect": {
          "offeringLinkedIn": "Offering to connect LinkedIn",
          "checkingLinkedIn": "Checking LinkedIn connection"
        },
        "research": {
          "checkingAnalytics": "Checking analytics",
          "checkingTrackedCompetitors": "Checking tracked competitors",
          "checkingCompetitorReport": "Checking the competitor analysis report",
          "checkingRecentContent": "Checking recent content",
          "readingPost": "Reading the post",
          "searchingWeb": "Searching the web",
          "readingWebPage": "Reading a web page",
          "checkingSimilarCompanies": "Checking for similar companies",
          "readingLinkedInPage": "Reading the LinkedIn page",
          "checkingPostHistory": "Checking post history",
          "checkingDesigns": "Checking your designs",
          "readingPrompts": "Reading your AI answer prompts",
          "readingPlan": "Reading the plan",
          "readingResearch": "Reading the research of a topic"
        },
        "competitor": {
          "adding": "Adding a competitor"
        },
        "competitors": {
          "analyzing": "Analyzing competitors"
        },
        "design": {
          "starting": "Starting a design",
          "checkingRun": "Checking the design run",
          "attachingToPost": "Attaching the design to the post",
          "addingReference": "Adding a reference image",
          "checkingReferences": "Checking reference images",
          "editing": "Changing the design",
          "checkingEdit": "Checking the design change"
        },
        "styleGuide": {
          "readingPosts": "Reading the brand's posts"
        },
        "visualStyle": {
          "checking": "Checking the visual style",
          "writing": "Writing Visual Style"
        },
        "onboarding": {
          "completing": "Completing onboarding"
        },
        "post": {
          "editing": "Editing the post",
          "publishingNow": "Publishing post now",
          "scheduling": "Scheduling post",
          "writing": "Writing a post"
        },
        "note": {
          "logging": "Logging a note"
        },
        "companyProfile": {
          "readingWebsite": "Reading the company website"
        },
        "brandFoundation": {
          "drafting": "Drafting the brand foundation"
        },
        "knowledgePage": {
          "writing": "Writing a knowledge page"
        },
        "document": {
          "writingNamed": "Writing your {name}",
          "writingGeneric": "Writing to a document",
          "approvingNamed": "Approving your {name}",
          "approvingGeneric": "Approving a document"
        },
        "stage": {
          "openingScreen": "Opening {screen}",
          "openingGeneric": "Opening a screen"
        },
        "workspace": {
          "listingFiles": "Listing workspace files",
          "readingFile": "Reading a workspace file",
          "writingFile": "Writing a workspace file",
          "editingFile": "Editing a workspace file",
          "deletingFile": "Deleting a workspace file",
          "renderingPage": "Rendering a page",
          "listingReferences": "Listing reference images",
          "readingReference": "Reading a reference image",
          "importingImage": "Importing an image"
        },
        "page": {
          "writing": "Writing the page",
          "adding": "Adding a page"
        },
        "topic": {
          "adding": "Adding a topic"
        }
      },
      "outcome": {
        "documentUpdated": "{name} updated",
        "documentApproved": "{name} approved",
        "styleGuideBuilt": "Built from {sampleCount} posts",
        "visualStyleSaved": "Visual Style saved",
        "companyProfileSaved": "Company profile saved",
        "competitorAdded": "{name} added",
        "competitorsAnalyzed": "{count} competitors analyzed",
        "designRunStarted": "Design started: {designName}",
        "designAttachedToPost": "Design attached to post",
        "designReferenceAdded": "{name} added",
        "postScheduled": "Post scheduled",
        "postPublished": "Post published",
        "postEdited": "Post updated",
        "noteLogged": "Note logged",
        "knowledgePageWritten": "{title} saved",
        "knowledgeOrganized": "Knowledge organized",
        "artifactLinked": "View {name}",
        "pageWriteStarted": "Page started: {title}",
        "postWriteStarted": "Post started",
        "pageAdded": "Page added: {title}",
        "designEditStarted": "Design change started",
        "topicAdded": "Topic added: {title}"
      }
    },
    "agentAsk": {
      "action": {
        "allow": "Allow",
        "notNow": "Not now",
        "done": "Done.",
        "declined": "You said no.",
        "expired": "This expired. Ask Raldo again if you still want it.",
        "cannotUndo": "This cannot be undone.",
        "failedNote": "You allowed this, but it did not go through: {reason}",
        "settled": "This request is settled."
      },
      "question": {
        "typeAnswer": "Type an answer",
        "answered": "Answered.",
        "expired": "This expired. Ask Raldo again if you still want it.",
        "settled": "This question is settled."
      },
      "connect": {
        "caption": "Publish and schedule posts directly from Raldo.",
        "connect": "Connect {platform}",
        "skip": "Skip for now",
        "connected": "{platform} connected.",
        "expired": "This expired. Ask Raldo again if you still want to connect.",
        "settled": "This connection request is settled."
      }
    },
    "sources": {
      "count": "1 source | {count} sources",
      "yourKnowledge": "Your knowledge"
    },
    "designSuggestions": {
      "label": "Suggested changes",
      "bigger": "Make this bigger",
      "dropRow": "Drop a row",
      "accent": "Use the accent colour",
      "moveUp": "Move it up a bit",
      "fit": "Make it fit"
    }
  },
  "home": {
    "yourBrandFallback": "your brand",
    "conversationStarted": "Conversation started.",
    "composerPlaceholders": [
      "Research a competitor",
      "Draft a post for LinkedIn",
      "Review {name}'s performance in the past month",
      "Plan content for the coming week"
    ],
    "demo": {
      "searchedCompetitorPricing": "Searched 6 competitor pricing pages for usage-based plans.",
      "comparedCompetitorFraming": "Compared how Competitor X frames overage charges versus committed usage tiers.",
      "answerMarkdown": "Here's how I'd position it: lead with **predictable growth, not punitive overages** -\nCompetitor X still frames usage pricing around penalty tiers, which reads as\nfear rather than value.\n\n- Anchor the headline on cost tracking value, not consumption\n- Show a side-by-side of \"pay for what breaks\" vs \"pay for what grows\"\n- Close with a customer quote on expansion revenue, not renewal fear\n\nWant me to turn this into a full one-pager for the sales team?"
    }
  },
  "setup": {
    "stepList": "Setup progress",
    "stepOf": "Step {number} of {total}",
    "stepDone": "Done",
    "founderLetter": {
      "title": "The journey begins",
      "greeting": "Hi {name},",
      "greetingAnonymous": "Hi there,",
      "intro": "I'm {name}, the founder of Raldo. {thanks}",
      "thanks": "I'm happy you're here. Thank you.",
      "story": "I built Raldo to solve my own problem: publishing relevant content every week that brings in new customers, without burning out. Today Raldo writes all of our content. If you found us, it worked at least once.",
      "plan": "Now it's your turn. Before Raldo can do anything for you, it has to understand your business and the industry you work in. This means facts about your brand, competitors and your customers. {time} Raldo will do the heavy lifting. Your job is judgment: tell it what's wrong and what could be better. {care} Everything Raldo makes for you will be built on this foundation.",
      "time": "Plan for about 15 minutes.",
      "care": "Please don't rush this part.",
      "closing": "Thanks again and let's get started.",
      "ps": "{label} If something looks wrong, or you just want to say what's up, write me at {email}. Raldo is AI, but my inbox is not. I read and answer every email myself.",
      "psLabel": "P.S.",
      "start": "Start setup"
    },
    "steps": {
      "brandFacts": {
        "title": "Brand facts",
        "heading": "Facts about your brand",
        "description": "What your company does and who it is for"
      },
      "competitors": {
        "title": "Competitors",
        "description": "The companies your customers compare you with"
      },
      "customerProfile": {
        "title": "Customer profile",
        "description": "Who your customers are"
      },
      "strategy": {
        "title": "Content strategy",
        "description": "The plan behind your content"
      },
      "visualStyle": {
        "title": "Visual style",
        "description": "How your posts look"
      }
    },
    "common": {
      "retry": "Try again",
      "edit": "Edit",
      "edited": "Edited",
      "sources": {
        "pages": "{count} page | {count} pages",
        "readFrom": "Raldo read this from"
      },
      "runErrors": {
        "generic": "Something went wrong. Try again.",
        "timedOut": "The read took too long. Try again."
      },
      "saved": "Saved"
    },
    "errors": {
      "startFailed": "We could not start the read",
      "confirmFailed": "We could not save this step"
    },
    "locked": {
      "change": "Change",
      "laterStepRunning": "Raldo is still working on a later step. Try again when it finishes.",
      "brandFacts": {
        "title": "You confirmed your brand facts",
        "body": "Raldo used them to find your competitors, and for your customer profile and your content strategy.",
        "alertTitle": "Change your brand facts?",
        "alertBody": "Raldo will look for your competitors again with the facts you confirm. Then it does your customer profile and your content strategy again. The new versions replace the saved ones, and your edits in those steps are lost. Then you confirm your visual style again.",
        "alertConfirm": "Change brand facts"
      },
      "competitors": {
        "title": "You confirmed these competitors",
        "body": "Raldo used them for your customer profile and your content strategy.",
        "alertTitle": "Change your competitors?",
        "alertBody": "Raldo will read the companies you pick. Then it does your customer profile and your content strategy again. The new versions replace the saved ones, and your edits in those steps are lost. Then you confirm your visual style again.",
        "alertConfirm": "Change competitors"
      },
      "customerProfile": {
        "title": "You confirmed your customer profile",
        "body": "Raldo used it for your content strategy.",
        "alertTitle": "Change your customer profile?",
        "alertBody": "Raldo will do your content strategy again from the profile you confirm. The new version replaces the saved one, and your edits there are lost. Then you confirm your visual style again.",
        "alertConfirm": "Change customer profile"
      },
      "strategy": {
        "title": "You confirmed your content strategy",
        "body": "Raldo uses it in everything it writes for you.",
        "alertTitle": "Change your content strategy?",
        "alertBody": "After you confirm the new strategy, you confirm your visual style again.",
        "alertConfirm": "Change content strategy"
      },
      "visualStyle": {
        "title": "You confirmed your visual style",
        "body": "Raldo uses it for the look of your posts."
      }
    },
    "loadFailed": {
      "title": "We could not load your setup",
      "line": "Check your connection and try again."
    },
    "ring": {
      "progress": "{done} of {total} pages read"
    },
    "brandFacts": {
      "links": {
        "subtitle": "Let's start from the very basics.",
        "website": {
          "label": "Website",
          "hint": "Enter your company's customer-facing landing page.",
          "placeholder": "https://yourcompany.com"
        },
        "linkedIn": {
          "label": "LinkedIn company page",
          "hint": "The link at the top of your company's LinkedIn page, when you \"View as member\". Only company pages work.",
          "placeholder": "https://linkedin.com/company/yourcompany"
        },
        "submit": "Read my pages",
        "next": "Next",
        "websiteError": "Enter a web address, like yourcompany.com.",
        "linkedInAddressError": "Enter a web address, like linkedin.com/company/yourcompany.",
        "linkedInError": "This is a personal profile. Enter your company page. It starts with linkedin.com/company/.",
        "editTitle": "Edit your links",
        "editHint": "Raldo reads your pages again and updates the sheet."
      },
      "reading": {
        "title": "Reading your pages",
        "ghost": "Reading",
        "stages": {
          "website": "Reading your website",
          "look": "Reading your logo and how you write",
          "extract": "Writing the facts"
        },
        "failedTitle": "We could not read your pages",
        "errors": {
          "websiteReadFailed": "We could not read your website. Check the link and try again.",
          "noPages": "We found no pages. Check your website link.",
          "extractionFailed": "We could not write the facts. Try again.",
          "enqueueFailed": "We could not start. Try again.",
          "readFailed": "Check your two links and try again."
        }
      },
      "sheet": {
        "readAgain": "Read again",
        "confirm": "Confirm",
        "ghost": {
          "region": "Add a country or region",
          "people": "Add a person",
          "text": "Not on your pages.",
          "textAction": "Write it in one line"
        },
        "regionCountries": "{count} country | {count} countries",
        "moreCountries": "and {count} more"
      },
      "summary": {
        "colours": "Brand colours",
        "dialogTitle": "Edit the summary",
        "lookTitle": "Logo, colours and font",
        "changeLater": "You can change these later on {section}, {page}.",
        "voiceTitle": "How you write",
        "openPage": "Open {page}",
        "voiceMissing": "Raldo couldn't read this from your site. Ask Raldo on {section}, {page} to try again."
      },
      "dialog": {
        "addPerson": "Add a person",
        "remove": "Remove",
        "name": "Name",
        "role": "Role",
        "regionLabel": "Region",
        "regionHint": "Type a country or a region. A region counts as every country in it.",
        "regionPlaceholder": "Type a country or a region",
        "regionEmpty": "No country or region matches that.",
        "regions": "Regions",
        "countries": "Countries",
        "inRegion": "in {region}",
        "nameRequired": "Add a name."
      },
      "runInProgress": "Raldo is already reading your pages. Wait for it to finish.",
      "rows": {
        "brandInCategory": {
          "name": "Brand in the category",
          "hint": "What you are, in one sentence. Raldo repeats it word for word.",
          "editTitle": "Edit brand in the category"
        },
        "category": {
          "name": "Category",
          "hint": "The words a customer uses to search",
          "editTitle": "Edit category"
        },
        "problemItSolves": {
          "name": "Problem it solves",
          "hint": "The problem your site says it fixes",
          "editTitle": "Edit problem it solves"
        },
        "targetCustomer": {
          "name": "Target customer",
          "hint": "The customer types named on your site",
          "editTitle": "Edit target customer"
        },
        "categoryDefinition": {
          "name": "Category definition",
          "hint": "The sentence that defines your category",
          "editTitle": "Edit category definition"
        },
        "approach": {
          "name": "Approach",
          "hint": "How you do it, and the idea behind that way",
          "editTitle": "Edit approach"
        },
        "region": {
          "name": "Region",
          "hint": "The countries you serve",
          "editTitle": "Edit region"
        },
        "people": {
          "name": "People",
          "hint": "Founders and team members named on your pages",
          "editTitle": "Edit people"
        }
      },
      "noRole": "No role yet"
    },
    "competitors": {
      "known": {
        "subtitle": "Who are you up against?",
        "lead": "Raldo goes looking for your competitors next. Got a name or two? Or you can let Raldo take the lead.",
        "namedTitle": "I know a few",
        "namedCaption": "Add one or two. Raldo looks for more like them.",
        "searchTitle": "Let Raldo look",
        "searchCaption": "Raldo starts from your brand facts. No homework for you."
      },
      "name": {
        "addLabel": "Who comes to mind?",
        "addHint": "One or two is plenty.",
        "start": "Find more like them"
      },
      "finding": {
        "errors": {
          "enqueueFailed": "We could not start the search. Try again.",
          "discoveryFailed": "We could not find companies like yours. Try again.",
          "timedOut": "The search took too long. Try again.",
          "startFailed": "We could not start the search. Try again."
        },
        "title": "Finding your competitors",
        "failedTitle": "We could not find your competitors",
        "stages": {
          "snapshot": "Reading what you already rank for",
          "similar": "Looking at companies like yours",
          "search": "Searching your category",
          "rank": "Sorting what we found"
        },
        "lists": {
          "similar": "Similar companies",
          "samePages": "Sites like yours",
          "comparisonPages": "Comparison pages",
          "searchRivals": "Search rivals",
          "namedRivals": "Rivals of the companies you named"
        },
        "found": "No companies found yet | {count} company found | {count} companies found"
      },
      "review": {
        "title": "Your competitors",
        "lead": "We found {count} companies and sorted them by how close they are to you. We ticked the {max} closest. Pick up to {max}.",
        "leadNamed": "We found {count} companies and sorted them by how close they are to you. We ticked the {named} you named. Pick up to {max}.",
        "groups": {
          "direct": {
            "title": "Closest competitors",
            "description": "They sell the same thing to the same customers."
          },
          "alternative": {
            "title": "Other options",
            "description": "Your customers can use these to do the same job in another way."
          },
          "notRelevant": {
            "title": "Also found",
            "description": "We think these are not competitors. Open the list if we are wrong."
          }
        },
        "pickName": "Pick {name}",
        "picked": "{count} of {max} picked",
        "picks": {
          "title": "Your picks",
          "empty": "Tick companies above or add one below.",
          "full": "You have picked {max} of {max}. Remove one above to add another.",
          "remove": "Remove {name}"
        },
        "added": "{name} added and picked.",
        "ticked": "{name} was already in {group}. It is picked now.",
        "addLabel": "Missing a company? Add it",
        "addHint": "A company you add is ticked for you.",
        "empty": "No companies found. Add at least one below.",
        "confirm": "Confirm",
        "sharesKeywords": "Ranks for {count} of your keywords"
      }
    },
    "customerProfile": {
      "reading": {
        "title": "Writing your customer profile",
        "failedTitle": "We could not write your customer profile",
        "detail": "From your brand facts and competitors",
        "ghost": "Writing",
        "errors": {
          "enqueueFailed": "We could not start writing the profile. Try again.",
          "draftFailed": "We could not write your customer profile. Try again.",
          "factsMissing": "We need your brand facts and competitors first. Check them, then try again.",
          "timedOut": "Writing the profile took too long. Try again.",
          "startFailed": "We could not start writing the profile. Try again."
        }
      },
      "profile": {
        "title": "Your customer",
        "subtitle": "The one person who feels the problem and makes the buying choice",
        "writeAgain": "Write again",
        "confirm": "Confirm",
        "editSummary": "Edit the summary",
        "untitled": "Your customer"
      },
      "job": {
        "title": "The job they hire for",
        "progress": "What they want",
        "goal": "Their goal",
        "stories": "When it matters",
        "when": "When",
        "want": "they want",
        "soThat": "so that",
        "editStory": "Edit this story"
      },
      "cards": {
        "tried": {
          "title": "What they use today",
          "hint": "What customers used before",
          "editTitle": "Edit what they have tried"
        },
        "blockers": {
          "title": "What holds them back",
          "hint": "What makes customers worry or wait",
          "editTitle": "Edit what they fear"
        }
      },
      "card": {
        "lines": "Lines",
        "addLine": "Add a line",
        "add": "Add",
        "removeLine": "Remove {label}",
        "lineTooLong": "One line is too long. Remove it and add a shorter one."
      },
      "summaryDialog": {
        "title": "Edit the summary",
        "hint": "The title, the company size and the summary",
        "titleLabel": "Title",
        "companySizeLabel": "Company size",
        "summaryLabel": "Summary",
        "writeAgain": "Write again"
      },
      "companySize": {
        "solo": "Just me",
        "upTo10": "2 to 10 people",
        "upTo50": "11 to 50 people",
        "upTo200": "51 to 200 people",
        "upTo1000": "201 to 1,000 people",
        "over1000": "Over 1,000 people"
      },
      "errors": {
        "writeSummaryFailed": "We could not write a new summary"
      },
      "limits": {
        "tooLong": "Use {max} characters or fewer."
      },
      "refusals": {
        "labelTooLong": "A line is too long. Make it shorter.",
        "labelRequired": "A line is empty. Type some words or remove the line.",
        "triedTooMany": "What they use today holds 4 lines at most. Remove one first.",
        "titleTooLong": "The title is too long. Make it shorter.",
        "summaryTooLong": "The summary is too long. Make it shorter.",
        "rowsEmpty": "Every card is empty. Add a line to a card first.",
        "runInProgress": "Raldo is still writing your customer profile. Wait for it to finish.",
        "factsMissing": "Confirm your brand facts first.",
        "competitorsMissing": "Add your competitors first.",
        "ownerAdminRequired": "Only an owner or admin can do this.",
        "editorRequired": "Your role can read this brand but cannot change it."
      }
    },
    "contentStrategy": {
      "reading": {
        "title": "Writing your content strategy",
        "failedTitle": "Raldo could not write your content strategy",
        "questions": "{done} of {total} questions",
        "writing": "Writing",
        "stages": {
          "awareness": "Writing what they must believe about the problem",
          "consideration": "Writing what they must believe about their options",
          "decision": "Writing what they must believe about you",
          "core": "Writing your core message"
        },
        "chips": {
          "awareness": "The problem",
          "consideration": "The options",
          "decision": "Why you",
          "core": "Core message"
        },
        "errors": {
          "enqueueFailed": "Raldo could not start writing. Try again.",
          "draftFailed": "Raldo could not write your content strategy. Try again.",
          "profileMissing": "Confirm your customer profile first. Then try again.",
          "factsMissing": "Confirm your brand facts first. Then try again.",
          "timedOut": "Writing took too long. Try again.",
          "startFailed": "Raldo could not start writing. Try again."
        }
      },
      "refusals": {
        "runInProgress": "Raldo is still writing your content strategy. Wait for it to finish.",
        "profileMissing": "Confirm your customer profile first.",
        "beliefMapMissing": "Raldo has not written your objectives yet.",
        "coreMessageMissing": "Write your core message first.",
        "strategyMissing": "Raldo has not written your content strategy yet.",
        "replacesTooLong": "What they think today can have 500 characters at most.",
        "ownerAdminRequired": "Only an owner or admin can do this.",
        "editorRequired": "Your role can read this brand but cannot change it."
      },
      "writeAgain": {
        "title": "Write again?",
        "body": "Raldo writes your content strategy again. The new text replaces the text you did not edit.",
        "confirm": "Write again"
      },
      "page": {
        "title": "Your content strategy",
        "writeAgain": "Write again",
        "confirm": "Confirm",
        "info": {
          "title": "Your content strategy sets the objective of every piece of content Raldo drafts.",
          "body": "Before buyers pick you, they must come to believe a few things: that their problem is real, that the usual fixes fall short, and that choosing you is safe. Raldo turns each of these into an argument and gives every piece of content one argument to make. Each one speaks to one reader: your target customer, at one stage of their journey from first noticing the problem to making the decision."
        }
      },
      "coreMessage": {
        "title": "The core message behind your content",
        "caption": "What prospects must believe in order to buy from you",
        "edit": "Edit your core message",
        "empty": "Raldo could not write your core message yet.",
        "write": "Write it",
        "yours": "Your core message"
      },
      "stages": {
        "awareness": {
          "objective": "Help them understand the problem",
          "note": "Your content explains the problem in their words and why it matters, without selling."
        },
        "consideration": {
          "objective": "Help them weigh their options",
          "note": "Your content helps them compare their options and see where your approach fits."
        },
        "decision": {
          "objective": "Help them choose with confidence",
          "note": "Your content explains how you work, what they get and what happens after they buy."
        }
      },
      "stage": {
        "heading": "{phase} · {objective}",
        "asks": "They ask: {question} {note}",
        "compareWith": "They compare you with"
      },
      "formats": {
        "howTo": "How-to guide",
        "research": "Research and data",
        "pointOfView": "Point of view",
        "comparison": "Comparison",
        "customerStory": "Customer story",
        "productExplainer": "Product explainer",
        "objection": "Objection answer",
        "pricing": "Pricing explained",
        "ourStory": "Our story"
      },
      "subjects": {
        "problem": "The problem",
        "prevalence": "How common it is",
        "cost": "Why it matters",
        "options": "The other options",
        "ourOption": "Your way",
        "fit": "Is it right for them",
        "brand": "Your company",
        "offer": "Your offer",
        "afterPurchase": "After they buy"
      },
      "ledger": {
        "thinks": "What they think today",
        "tells": "What your content tells them",
        "quoted": "“{quote}”",
        "edit": "Edit this objective: {subject}"
      },
      "end": {
        "title": "Ready to decide",
        "body": "They have what they need to consider you"
      },
      "objectiveDialog": {
        "title": "Edit this objective",
        "eyebrow": "{phase} · {subject}"
      },
      "coreMessageDialog": {
        "title": "Edit your core message",
        "description": "One sentence a buyer must accept before choosing you. Name your company once, {max} words at most.",
        "words": "{count} / {max} words"
      }
    },
    "visualStyle": {
      "choice": {
        "title": "Visual style",
        "lead": "It's time to define your brand's visuals for social media posts. Got designs people know you by? Or pick a template from Raldo's library.",
        "ownTitle": "I have my own designs",
        "ownCaption": "Drop in a few visuals. Raldo will turn them into a reusable design for all content.",
        "templatesTitle": "Show me templates",
        "templatesCaption": "Pick a template and customise it to your style."
      },
      "templates": {
        "title": "Pick a template",
        "lead": "Every template is a full set of slides for your carousels. We show them in your colours, with your logo.",
        "kitLabel": "Your brand kit",
        "kit": {
          "logo": "Logo",
          "logoMark": "Logo mark",
          "colours": "Colours",
          "font": "Font",
          "fontNotSet": "Not set",
          "editLogo": "Edit logo",
          "editLogoMark": "Edit logo mark",
          "editColours": "Edit colours",
          "editFont": "Edit font"
        },
        "colourMode": "Colours shown",
        "modeBrand": "Your colours",
        "modeTemplate": "Template colours",
        "filterLabel": "Filter the templates",
        "filterAll": "All",
        "filterLight": "Light",
        "filterDark": "Dark",
        "ownTitle": "Your own designs",
        "ownCaption": "Drop a few posts here, or click to upload",
        "cover": "{name} template",
        "failed": "Raldo could not load the templates. Try again."
      },
      "template": {
        "accent": "Accent colour",
        "accentFirst": "Your first colour",
        "fonts": "Fonts",
        "fontsLabel": "Fonts of the template",
        "later": "You can change the template later in Style.",
        "allTemplates": "All templates",
        "use": "Use this template"
      },
      "own": {
        "title": "Your own designs",
        "lead": "Add posts or slides that you like. Raldo builds a template from them with every slide type your posts need.",
        "uploadTitle": "Your designs",
        "uploadCount": "{count} added",
        "add": "Add",
        "design": "Design {n}",
        "noticeTitle": "Raldo builds your template after setup",
        "notice": "We tell you when it is ready.",
        "back": "Back",
        "finish": "Finish setup"
      },
      "errors": {
        "strategyMissing": "Confirm your content strategy first.",
        "designsMissing": "Some of your designs are no longer in your media library. Add them again.",
        "roleRequired": "Only an owner or admin can confirm this step."
      }
    }
  },
  "tour": {
    "basics": {
      "composer": {
        "title": "Ask for the work, not the tool",
        "body": "Say \"plan next week\" or \"research a competitor\" and I do it. I write to your board, your designs and your brand myself."
      },
      "nav": {
        "title": "Where my work lands",
        "body": "Chat, Inbox, Board and Visibility are where you work. Content holds your pages, posts, strategy and media. Brand is what I know about you: profile, style, competitors and knowledge. Everything I write comes from it."
      },
      "dock": {
        "title": "I read the screen you are on",
        "body": "Open me anywhere with Cmd or Ctrl and J. I can see the post or the chart in front of you, so \"rewrite this\" is enough."
      },
      "hub": {
        "title": "More of this, when you want it",
        "body": "Every tour lives here if you want one again, and you can turn the tips off for good."
      }
    },
    "content": {
      "board": {
        "title": "Right-click is the shortcut",
        "body": "Schedule, publish now, duplicate and delete all live in that menu. A single click just peeks the post open next to me."
      },
      "plan": {
        "title": "I can fill the whole period",
        "body": "Give me a period and I plan one post for each of your posting days from your arguments and topics, then write the drafts. The canvas opens so you can watch them land side by side."
      }
    },
    "brand": {
      "foundation": {
        "title": "What I write from",
        "body": "Profile holds your brand facts and the customer you write for. Change either and everything I write after it follows."
      },
      "style": {
        "title": "How it sounds and looks",
        "body": "Voice decides how your posts sound, Visual style how your designs look. I read both from your site during setup, and every draft follows them."
      }
    },
    "controls": {
      "next": "Next",
      "back": "Back",
      "skip": "Skip",
      "done": "Done",
      "gotIt": "Got it",
      "close": "Close the tip",
      "step": "Step {index} of {total}"
    },
    "handoff": {
      "title": "Want a quick tour?",
      "body": "Four short stops: the composer, the nav, the chat dock and this hub.",
      "accept": "Show me around",
      "decline": "Not now"
    },
    "hub": {
      "label": "Show me around",
      "title": "{done} of {total} tours seen",
      "replay": "Replay",
      "start": "Start",
      "turnOff": "Turn tips off",
      "turnOn": "Turn tips on",
      "allSeen": "You have seen every tour.",
      "tours": {
        "basics": "The basics",
        "content": "Content",
        "brand": "Brand"
      }
    }
  },
  "editor": {
    "shell": {
      "closeEditor": "Close editor",
      "designName": "Design name",
      "save": "Save",
      "saving": "Saving",
      "exportPng": "Export PNG"
    },
    "canvas": {
      "region": "Canvas",
      "zoomOut": "Zoom out",
      "zoomIn": "Zoom in",
      "zoomToFit": "Zoom to fit",
      "resetZoom": "Reset zoom to 100 percent",
      "selectNamed": "Select {name}",
      "selectItem": "Select item"
    },
    "export": {
      "exporting": "Exporting…"
    },
    "border": {
      "title": "Border",
      "selectShape": "Select a shape or a text to add a border.",
      "add": "Add border",
      "color": "Border color",
      "width": "Border width",
      "remove": "Remove border"
    },
    "color": {
      "fill": "Fill color",
      "fillOpacity": "Fill opacity",
      "text": "Text color",
      "background": "Background color",
      "noColor": "This layer has no color to edit.",
      "none": "No color",
      "custom": "Custom",
      "customAria": "Custom color",
      "back": "Back",
      "inThisDesign": "In this design",
      "colorPalette": "Color palette",
      "defaultColors": "Default colors",
      "defaultGradients": "Default gradients",
      "seeAll": "See all",
      "solid": "Solid color",
      "gradient": "Gradient",
      "paintType": "Paint type",
      "gradientColors": "Gradient colors",
      "style": "Style",
      "addColor": "Add color",
      "removeColor": "Remove color {number}",
      "colorNumber": "Color {number}",
      "styleLinear90": "90°",
      "styleLinear180": "180°",
      "styleLinear135": "135°",
      "styleRadialCenter": "Center",
      "styleRadialCorner": "Corner",
      "groupCool": "Cool tones",
      "groupWarm": "Warm tones",
      "groupMonochromatic": "Monochromatic",
      "groupAll": "All gradients",
      "applyGradient": "Gradient {number}"
    },
    "common": {
      "advanced": "Advanced"
    },
    "editImage": {
      "title": "Edit image",
      "selectImage": "Select an image",
      "selectImageHint": "Adjustments, shape mask, and crop apply to a selected image.",
      "replace": "Replace",
      "replaceWith": "Replace with",
      "sectionsAria": "Edit image sections",
      "tabAdjust": "Adjust",
      "tabFrame": "Shape mask",
      "adjustments": "Adjustments",
      "brightness": "Brightness",
      "contrast": "Contrast",
      "frame": "Shape mask",
      "frameShapeAria": "Shape mask",
      "frameNone": "None",
      "frameCircle": "Circle",
      "frameRounded": "Rounded",
      "frameTriangle": "Triangle",
      "crop": "Crop",
      "cropAspectRatioAria": "Crop aspect ratio",
      "cropTo": "Crop to {preset}"
    },
    "library": {
      "heading": "Your library",
      "uploadImage": "Upload image",
      "upload": "Upload",
      "loading": "Loading your library",
      "empty": "No images yet"
    },
    "action": {
      "cut": "Cut",
      "copy": "Copy",
      "paste": "Paste",
      "duplicate": "Duplicate",
      "duplicateShortcut": "Duplicate (⌘D)",
      "deleteShortcut": "Delete (⌫)",
      "bringToFront": "Bring to Front",
      "bringForward": "Bring Forward",
      "sendBackward": "Send Backward",
      "sendToBack": "Send to Back",
      "group": "Group",
      "ungroup": "Ungroup",
      "layerActionsAria": "Layer actions"
    },
    "toolbar": {
      "askRaldo": "Ask Raldo about this",
      "title": "Editor tools",
      "layerSelected": "A layer is selected",
      "noSelection": "No selection",
      "undo": "Undo",
      "undoShortcut": "Undo (⌘Z)",
      "redo": "Redo",
      "redoShortcut": "Redo (⇧⌘Z)",
      "addImage": "Add image",
      "addText": "Add text",
      "addShape": "Add shape",
      "addFrame": "Add frame",
      "rectangle": "Rectangle",
      "ellipse": "Ellipse",
      "add": "Add",
      "lock": "Lock",
      "unlock": "Unlock",
      "transparency": "Transparency",
      "label": "Label",
      "transparentGround": "No fill",
      "clipContents": "Clip contents"
    },
    "layout": {
      "title": "Auto layout",
      "selectFrame": "Select a frame to lay out its contents.",
      "explainer": "A frame with auto layout positions its own contents, so longer copy pushes what follows down instead of running under it.",
      "enable": "Add auto layout",
      "disable": "Remove auto layout",
      "direction": "Direction",
      "column": "Column",
      "row": "Row",
      "align": "Alignment",
      "alignStart": "Start",
      "alignCenter": "Center",
      "alignEnd": "End",
      "gap": "Gap",
      "padding": "Padding",
      "paddingTop": "Top",
      "paddingRight": "Right",
      "paddingBottom": "Bottom",
      "paddingLeft": "Left",
      "linkPadding": "Link all sides",
      "unlinkPadding": "Set each side separately",
      "justify": "Justify",
      "justifyStart": "Start",
      "justifyCenter": "Center",
      "justifyEnd": "End",
      "justifySpaceBetween": "Space between",
      "justifySpaceAround": "Space around",
      "justifySpaceEvenly": "Space evenly",
      "wrap": "Wrap",
      "positionOwnedByLayout": "The auto layout that holds this layer decides where it sits.",
      "sizingWidth": "Width",
      "sizingHeight": "Height",
      "sizingFixed": "Fixed",
      "sizingHug": "Hug",
      "sizingFill": "Fill",
      "escapeLayout": "Escape layout",
      "escapeLayoutHint": "Take this layer out of the auto layout above it. It keeps its own position, and the layout arranges as if it isn't here.",
      "returnToLayoutHint": "Hand this layer back to the auto layout above it."
    },
    "properties": {
      "title": "Design properties",
      "show": "Show properties",
      "hide": "Hide properties",
      "close": "Close properties",
      "contextText": "Text",
      "contextImage": "Image",
      "contextShape": "Shape",
      "contextFrame": "Frame",
      "contextPage": "Page",
      "contextSelection": "Selection",
      "format": "Format",
      "artboardFormat": "Artboard format",
      "fontSize": "Font size",
      "bold": "Bold",
      "italic": "Italic",
      "fontFamily": "Font family",
      "alignLeft": "Align left",
      "alignCenter": "Align center",
      "alignRight": "Align right",
      "hugContents": "Fit to text",
      "textEffects": "Text effects",
      "effects": "Effects",
      "labelForRaldo": "Label for Raldo",
      "cornerRounding": "Corner rounding",
      "position": "Position",
      "opacity": "Opacity",
      "editingShared": "Editing the shared properties of 1 layer. | Editing the shared properties of {count} layers."
    },
    "position": {
      "sectionAria": "Position panel section",
      "arrange": "Arrange",
      "layers": "Layers",
      "forward": "Forward",
      "backward": "Backward",
      "toFront": "To front",
      "toBack": "To back",
      "alignToPage": "Align to page",
      "top": "Top",
      "left": "Left",
      "middle": "Middle",
      "center": "Center",
      "bottom": "Bottom",
      "right": "Right",
      "sizeAndPosition": "Size and position",
      "w": "W",
      "h": "H",
      "x": "X",
      "y": "Y",
      "width": "Width",
      "height": "Height",
      "positionX": "Position X",
      "positionY": "Position Y",
      "rotate": "Rotate",
      "rotationDegrees": "Rotation in degrees",
      "lockRatio": "Lock aspect ratio",
      "unlockRatio": "Unlock aspect ratio",
      "selectionBoundsHint": "Selection bounds. Use Align & Distribute to position multiple layers.",
      "selectLayerHint": "Select a layer to edit its size and position.",
      "group": "Group",
      "distribute": "Distribute",
      "horizontal": "Horizontal",
      "vertical": "Vertical",
      "noLayers": "No layers yet",
      "renameLayer": "Rename layer",
      "moveForward": "Move layer forward",
      "moveBackward": "Move layer backward",
      "toggleVisibility": "Toggle layer visibility",
      "toggleLock": "Toggle layer lock",
      "collapseLayer": "Collapse layer",
      "expandLayer": "Expand layer"
    },
    "opacity": {
      "selectLayer": "Select a layer to adjust its opacity."
    },
    "page": {
      "sectionAria": "Page panel section",
      "forRaldo": "For Raldo",
      "textRaldoWrites": "Text Raldo writes",
      "picturesRaldoAsksFor": "Pictures Raldo asks for",
      "notLabelled": "Not labelled",
      "noSlots": "Nothing on this page is labelled for Raldo yet. Select a text or image layer and give it a label.",
      "emptySlot": "Empty",
      "charLimit": "Limit: {count} characters",
      "add": "Add page",
      "delete": "Delete page",
      "duplicate": "Duplicate page",
      "moveLeft": "Move page left",
      "moveRight": "Move page right"
    },
    "text": {
      "uppercase": "Uppercase",
      "spacing": "Spacing",
      "letterSpacing": "Letter spacing",
      "lineSpacing": "Line spacing",
      "anchor": "Anchor text box",
      "anchorTop": "Grow downward",
      "anchorMiddle": "Grow from the middle",
      "anchorBottom": "Grow upward",
      "anchorHint": "Which edge stays put when the text gets longer or shorter.",
      "selectText": "Select a text layer to set its spacing."
    },
    "background": {
      "title": "Background",
      "detach": "Detach",
      "remove": "Remove background"
    },
    "panel": {
      "collapse": "Collapse panel",
      "expand": "Expand panel"
    },
    "textEffects": {
      "selectLayer": "Select a text layer",
      "selectLayerHint": "Text effects apply to a selected text layer.",
      "addBackground": "Add text background",
      "background": "Text background",
      "removeBackground": "Remove text background",
      "backgroundColor": "Background color",
      "backgroundRoundness": "Background roundness",
      "padding": "Padding",
      "backgroundOpacity": "Background opacity",
      "none": "None",
      "backgroundTile": "Background",
      "specimen": "Ag",
      "roundness": "Roundness",
      "opacity": "Opacity"
    },
    "nodeEffects": {
      "selectLayer": "Select a layer",
      "selectLayerHint": "Effects apply to the selected layer.",
      "none": "None",
      "shadowTile": "Shadow",
      "shadow": "Shadow",
      "distance": "Distance",
      "direction": "Direction",
      "softness": "Softness",
      "spread": "Spread",
      "shadowColor": "Shadow color",
      "shadowOpacity": "Shadow opacity"
    },
    "insert": {
      "title": "Insert",
      "back": "Back",
      "tabsAria": "What to insert",
      "scrollTabsPrev": "Scroll left",
      "scrollTabsNext": "Scroll right",
      "tabTemplates": "Templates",
      "tabElements": "Elements",
      "tabImages": "Images",
      "tabText": "Text",
      "tabShapes": "Shapes",
      "kind": {
        "background": "Backgrounds",
        "shape": "Shapes",
        "separator": "Separators",
        "decoration": "Decoration"
      },
      "noTemplates": "No templates yet.",
      "noElements": "No elements yet.",
      "applyTemplate": "Apply the template {name} to this page",
      "appendTemplate": "Add the template {name} as a new page",
      "openTemplate": "Open the template {name}",
      "applyAllPages": "Apply all {count} pages",
      "applyTemplatePage": "Apply page {number} to this page",
      "templateMeta": "{width} × {height} px · {count} pages",
      "templatePages": "{count} pages",
      "placeElement": "Add the element {name}",
      "addHeading": "Add heading",
      "addSubheading": "Add subheading",
      "shapesHint": "A frame groups what you put inside it and can lay it out for you.",
      "elementSaved": "Saved as an element.",
      "elementSaveFailed": "That element could not be saved.",
      "elementRenameFailed": "That element could not be renamed.",
      "elementDeleteFailed": "That element could not be deleted.",
      "saveAsElement": "Save as element",
      "saveElementBody": "Store this selection so you can drop it into any design.",
      "elementName": "Name",
      "elementNamePlaceholder": "Blue halo",
      "elementKind": "Group",
      "elementBleed": "Cover the whole page",
      "elementBleedHint": "A covering element scales to the page and lands behind everything already on it."
    },
    "cornerRadius": {
      "selectLayer": "Select a shape, image or frame to adjust its corner rounding.",
      "value": "Corner rounding value"
    },
    "slotLabel": {
      "selectLayer": "Select a text or image layer",
      "selectLayerHint": "Labelling tells Raldo what a field is and how to fill it.",
      "addLabel": "Add label",
      "removeLabel": "Remove label",
      "role": "Role",
      "roleHint": "Short kebab-case name, e.g. page-title",
      "limitLength": "Limit length",
      "maxLength": "Max length"
    },
    "generating": {
      "drafting": "Drafting"
    },
    "conflict": {
      "title": "This design changed elsewhere",
      "description": "Someone else saved changes to this design after you opened it. Your local edits are still here, but saving again will keep failing until you reload. Reload to load the latest version, or keep editing and reload before you try to save.",
      "keepEditing": "Keep editing",
      "reload": "Reload"
    },
    "view": {
      "loading": "Loading this design",
      "notFound": "Design not found",
      "backToMedia": "Back to Media",
      "draftingToast": "Raldo is drafting your post.",
      "discardTitle": "Discard your unsaved changes?",
      "discardDescription": "This design has edits you have not saved. Leaving now throws them away.",
      "unsavedChanges": "This design has unsaved changes."
    },
    "defaults": {
      "text": "Text",
      "image": "Image",
      "frame": "Frame",
      "ellipse": "Ellipse",
      "rectangle": "Rectangle",
      "artboard": "Artboard",
      "pageNumber": "Page {number}"
    },
    "format": {
      "square": "Square",
      "portrait": "Portrait",
      "story": "Story"
    },
    "crop": {
      "presetOriginal": "Original",
      "preset1x1": "1:1",
      "preset4x5": "4:5",
      "preset16x9": "16:9",
      "preset9x16": "9:16"
    }
  },
  "primitives": {
    "loading": "Loading",
    "breadcrumb": {
      "ariaLabel": "Breadcrumb",
      "moreAriaLabel": "Show the folders in between"
    },
    "dateTimePicker": {
      "setDateTime": "Set date & time",
      "setDates": "Set dates",
      "previousMonth": "Previous month",
      "nextMonth": "Next month",
      "time": "Time",
      "hour": "Hour",
      "minute": "Minute",
      "set": "Set"
    },
    "dropzone": {
      "dragDropTitle": "Drag & drop files here",
      "clickToBrowse": "or click to browse",
      "triggerAriaLabel": "{title}. {subtitle}",
      "filesSelected": "1 file selected | {count} files selected",
      "filesSelectedWithIgnored": "1 file selected, {ignored} ignored (didn't match accepted types) | {count} files selected, {ignored} ignored (didn't match accepted types)"
    },
    "expandableText": {
      "showMore": "Show more",
      "showLess": "Show less"
    },
    "field": {
      "required": "(Required)",
      "optional": "(Optional)"
    },
    "keyboard": {
      "controlKey": "Ctrl"
    },
    "languageSelect": {
      "ariaLabel": "Language: {language}"
    },
    "markdownEditor": {
      "editorLabel": "Markdown editor",
      "askRaldo": "Ask Raldo",
      "bold": "Bold",
      "italic": "Italic",
      "strikethrough": "Strikethrough",
      "heading": "Heading",
      "bulletList": "Bullet list",
      "numberedList": "Numbered list",
      "quote": "Quote",
      "link": "Link",
      "linkText": "link text",
      "url": "url",
      "toggleTask": "Toggle task",
      "textFormatting": "Text formatting",
      "selectionFormatting": "Selection formatting",
      "insertBlock": "Insert block",
      "hookBoundaryLabel": "First {count} characters visible in feed"
    },
    "numberInput": {
      "decrement": "Decrement",
      "increment": "Increment"
    },
    "toast": {
      "close": "Close"
    },
    "toaster": {
      "notifications": "Notifications"
    },
    "chart": {
      "noData": "No data for this period",
      "labelValue": "{label}: {value}",
      "valueCaption": "{value} · {caption}",
      "fractionSr": "{value} of {total} {label}",
      "rank": "#{rank}",
      "axisRangeSr": "Horizontal axis from {xLow} to {xHigh}, vertical axis from {yLow} to {yHigh}",
      "pointSr": "{label} - horizontal {x} of 100, vertical {y} of 100",
      "bubbleSr": "{label}: {xLabel} {x}, {yLabel} {y}",
      "bubbleAxesSummary": "{xLabel} {x}, {yLabel} {y}",
      "seriesLabelValue": "{series}, {label}: {value}",
      "seriesValues": "{series}: {values}"
    },
    "delta": {
      "percent": "{value}%",
      "points": "{value} pts",
      "absolute": "{value}",
      "unchanged": "unchanged"
    },
    "colorInput": {
      "brandColor": "Brand color",
      "hexValue": "{label} hex value"
    },
    "colorPicker": {
      "square": "Saturation and brightness",
      "hue": "Hue",
      "opacity": "Opacity",
      "hex": "Hex colour"
    },
    "aiEngine": {
      "chatgpt": "ChatGPT",
      "perplexity": "Perplexity",
      "google": "Google AI Overview"
    }
  },
  "revisionHistory": {
    "loading": "Loading the history",
    "generated": "{author} generated this version.",
    "edited": "{author} edited it.",
    "rewritten": "{author} rewrote it.",
    "restored": "{author} restored an earlier version.",
    "instructionAsked": "You asked: \"{instruction}\"",
    "current": "Current",
    "restore": "Restore",
    "restoreAria": "Restore the version from {date}"
  },
  "knowledge": {
    "searchPlaceholder": "Search knowledge",
    "noMatches": "No page matches that.",
    "newPage": "New page",
    "loading": "Loading your knowledge",
    "loadError": "Your knowledge could not be loaded",
    "emptyTitle": "Nothing written down yet",
    "emptyBody": "Knowledge pages hold what is true about your product: what it does, what it costs, who buys it. Raldo writes from them every time it drafts a post.",
    "askRaldo": "Ask Raldo to read your site",
    "askRaldoToRead": "Read my website and write up what my product does, what it costs and who buys it.",
    "titleLabel": "Page title",
    "titlePlaceholder": "What is this page about?",
    "bodyLabel": "Page body",
    "bodyPlaceholder": "Write what is true about your product.",
    "outlineLabel": "Page outline",
    "writtenFrom": "Written from",
    "historyLabel": "History",
    "notFoundTitle": "That page does not exist",
    "notFoundBody": "It may have been deleted, or the link may be wrong.",
    "backToLibrary": "Back to Knowledge",
    "deleteTitle": "Delete this page?",
    "deleteBody": "The page and its whole history go for good, and Raldo stops writing from it.",
    "reading": "Reading {site}",
    "readingBatch": "batch {done} of {total}",
    "readingPages": "{selected} of {found} pages, chosen by what you link from your homepage.",
    "bucket": {
      "productsAndServices": "Products and services",
      "pricing": "Pricing",
      "customersAndBuyers": "Customers and buyers",
      "howItWorks": "How it works"
    },
    "foldersHeading": "Folders",
    "pagesHeading": "Pages",
    "newFolder": "New folder",
    "newFolderTitle": "New folder",
    "renameFolder": "Rename",
    "renameFolderTitle": "Rename folder",
    "folderNameLabel": "Folder name",
    "folderNamePlaceholder": "What goes in here?",
    "folderNameTaken": "A folder here already carries that name.",
    "folderNameTooLong": "Keep the name to {count} characters or fewer.",
    "folderCreate": "Create",
    "folderCount": "1 folder | {count} folders",
    "pageCount": "1 page | {count} pages",
    "folderEmpty": "Empty",
    "folderEmptyTitle": "Nothing in this folder yet",
    "folderEmptyBody": "Write a page here, or drag one in from somewhere else.",
    "moveAction": "Move to folder…",
    "moveTitle": "Move to folder",
    "moveBody": "Pick where this belongs.",
    "moveConfirm": "Move",
    "itemActions": "Actions for {name}",
    "itemActionsMenu": "Item actions",
    "deleteFolderTitle": "Delete this folder?",
    "deleteFolderBody": "The folder goes. Everything inside it moves up to the folder above, so nothing you wrote is lost.",
    "slugTakenTitle": "A page with this title already exists.",
    "slugTakenAction": "Open it",
    "toast": {
      "saveFailed": "The page could not be saved",
      "restoreFailed": "That version could not be restored",
      "deleteFailed": "The page could not be deleted",
      "folderCreateFailed": "The folder could not be created",
      "folderRenameFailed": "The folder could not be renamed",
      "folderDeleteFailed": "The folder could not be deleted",
      "moveFailed": "That could not be moved"
    },
    "openFullPage": "Open full page",
    "morePages": "1 more | {count} more",
    "preview": {
      "openFull": "Open full page",
      "close": "Close preview",
      "askPlaceholder": "Ask Raldo about this page"
    },
    "unsavedChanges": "This page has unsaved changes."
  },
  "quickLook": {
    "loading": "Loading the preview",
    "unavailable": "This image could not be loaded",
    "previous": "Previous item",
    "next": "Next item",
    "position": "{index} of {count}",
    "close": "Close preview"
  },
  "design": {
    "view": {
      "loading": "Loading the design",
      "notFoundTitle": "Design not found",
      "notFoundDescription": "This design may have been deleted.",
      "attachAction": "Attach to post",
      "backToPost": "Back to the post",
      "documentError": "The design file could not be read. Try again."
    },
    "page": {
      "loading": "Loading page {page}",
      "error": "This page could not be loaded",
      "alt": "Page {page}"
    },
    "carousel": {
      "label": "Design pages",
      "previous": "Previous page",
      "next": "Next page",
      "status": "Page {page} of {count}"
    },
    "status": {
      "loading": "Loading run history",
      "running": "Raldo is making the design. It takes a few seconds.",
      "completed": "The design is ready.",
      "failed": "The design could not be made. {reason}",
      "reasons": {
        "design_run_enqueue_failed": "It did not start. Try again.",
        "design_run_failed": "Something went wrong. Try again.",
        "design_render_failed": "The pages could not be drawn. Try again.",
        "design_attach_failed": "It could not be added to the post. Try again.",
        "run_timed_out": "It took too long. Try again.",
        "unknown": "Try again."
      }
    },
    "attachToPost": {
      "title": "Attach to a post",
      "description": "Pick a draft post for this design to become its artwork.",
      "emptyTitle": "No drafts yet",
      "emptyDescription": "Create a draft post first, then attach this design to it.",
      "untitled": "Untitled post",
      "confirm": "Attach",
      "attaching": "Attaching",
      "success": "Design attached to post"
    },
    "runBadge": {
      "running": "Making",
      "failed": "Failed"
    },
    "editor": {
      "errorTitle": "The design could not be opened",
      "frameTitle": "Page {page}",
      "pages": {
        "summary": "{count} page · Portrait 4:5 | {count} pages · Portrait 4:5",
        "label": "Pages",
        "item": "Page {page}, {layout}",
        "moveUp": "Move page up",
        "moveDown": "Move page down",
        "duplicate": "Duplicate page",
        "delete": "Delete page",
        "add": "Add page"
      },
      "canvas": {
        "label": "Design page",
        "page": "Page {page}",
        "previous": "Previous page",
        "next": "Next page",
        "position": "{page} / {count}"
      },
      "inspector": {
        "page": "Page {page}",
        "groups": {
          "argument": "Argument layout from {template}",
          "announcement": "Announcement layout from {template}",
          "brand": "Brand layout from {template}"
        },
        "editTitle": "Edit anything on the page",
        "editBody": "Click a text, a picture or a shape on the page to style it, move it or change it.",
        "copyTitle": "This design is its own copy",
        "copyBody": "Changes stay in this design. They never touch your brand style or the template.",
        "title": "Inspector",
        "change": "Change",
        "pageColour": "Page colour",
        "designColours": "Design colours",
        "fonts": {
          "headings": "Headings font",
          "text": "Text font"
        },
        "text": "Text",
        "weight": "Weight",
        "weights": {
          "w400": "Regular",
          "w500": "Medium",
          "w600": "Semibold",
          "w700": "Bold",
          "w800": "Extra bold"
        },
        "case": "Case",
        "cases": {
          "none": "Normal",
          "uppercase": "Capitals"
        },
        "colour": "Colour",
        "picture": "Picture",
        "position": "Position",
        "x": "X",
        "y": "Y",
        "width": "Width",
        "rotation": "Rotation",
        "appearance": "Appearance",
        "opacity": "Opacity",
        "arrange": "Arrange",
        "forward": "Forward",
        "backward": "Backward",
        "duplicate": "Duplicate",
        "delete": "Delete",
        "reset": "Reset to the layout",
        "kind": {
          "slot": "Raldo wrote this from the post. If you change the words here, the post's copy changes too. The way you style or move it stays.",
          "part": "Part of the {template} layout. Style it, move it or remove it; Raldo leaves it as you set it.",
          "free": "You added it, only on this page. Raldo leaves it as you set it."
        },
        "slidesDiffer": "The post and this design have different slides."
      },
      "layouts": {
        "title": "Title",
        "statement": "Statement",
        "statement-2": "Statement 2",
        "statement-3": "Statement 3",
        "stat": "Stat",
        "quote": "Quote",
        "contrast": "Contrast",
        "example": "Example",
        "takeaway": "Takeaway",
        "product": "Product",
        "features": "Features",
        "service": "Service",
        "included": "What's included",
        "person": "Person",
        "event": "Event",
        "sign-off": "Sign-off"
      },
      "save": {
        "saved": "Saved",
        "saving": "Saving",
        "failed": "Could not save",
        "stale": "Changed elsewhere",
        "reload": "Reload",
        "failedToast": "The design could not be saved",
        "staleToast": "This design changed somewhere else. Reload to keep editing.",
        "refused": {
          "invalid": "The design file is not valid.",
          "styles": "The design's styles cannot be changed here.",
          "editorRole": "Only an editor can change this design."
        }
      },
      "history": {
        "undo": "Undo",
        "redo": "Redo"
      },
      "slots": {
        "eyebrow": "Eyebrow",
        "headline": "Headline",
        "subhead": "Subhead",
        "bridge": "Bridge",
        "cue": "Cue",
        "images": "Picture",
        "body": "Body text",
        "value": "Value",
        "label": "Label",
        "quote": "Quote",
        "attribution": "Attribution",
        "before": "Before",
        "after": "After",
        "close": "Closing line",
        "next": "Next step",
        "action": "Action",
        "name": "Name",
        "rows": "List",
        "role": "Role",
        "line": "Line",
        "date": "Date",
        "place": "Place",
        "what": "What",
        "logo": "Logo",
        "brandName": "Brand name",
        "tagline": "Tagline",
        "pageCounter": "Page number"
      },
      "parts": {
        "picture": "Picture",
        "text": "Text",
        "shape": "Shape"
      },
      "toasts": {
        "undo": "Undo",
        "slotRemoved": "{name} removed from this page. Raldo will not write it here again.",
        "duplicated": "Duplicated. The copy is a free element, so Raldo will not refill it.",
        "layoutChanged": "Changed to {layout}. The words moved into the slots that fit; free edits on this page were left behind.",
        "slotSaved": "Saved. The post's copy on page {page} changed too.",
        "pageDeleted": "Page deleted."
      },
      "panels": {
        "label": "Left panel",
        "pages": "Pages",
        "insert": "Insert"
      },
      "toolbar": {
        "label": "Page tools",
        "typing": "Typing in {name}",
        "done": "Done",
        "insert": "Insert",
        "pageColour": "Page colour",
        "changeLayout": "Change layout",
        "font": "Font",
        "size": "Size",
        "textColour": "Text colour",
        "colour": "Colour",
        "bold": "Bold",
        "capitals": "Capitals",
        "alignment": "Alignment",
        "alignLeft": "Align left",
        "alignCenter": "Align centre",
        "alignRight": "Align right",
        "replace": "Replace",
        "askRaldo": "Ask Raldo"
      },
      "colours": {
        "accent": "Accent",
        "ground": "Ground",
        "ink": "Ink",
        "surface": "Surface",
        "layout": "Use the layout colour"
      },
      "pictures": {
        "numbered": "Picture {number}",
        "none": "This design holds no pictures yet."
      },
      "insert": {
        "label": "Insert",
        "text": "Text",
        "heading": "Heading",
        "subheading": "Subheading",
        "body": "Body text",
        "headingSample": "Heading",
        "subheadingSample": "Subheading",
        "bodySample": "Body text",
        "pieces": "Pieces",
        "artwork": "Artwork",
        "shapes": {
          "pointer": "Pointer",
          "rectangle": "Rectangle",
          "circle": "Circle",
          "line": "Line",
          "tape": "Tape strip"
        },
        "icons": "Icons",
        "pictures": "Pictures",
        "brand": "Brand",
        "logo": "Logo",
        "brandName": "Brand name"
      },
      "picker": {
        "addTitle": "Add a page",
        "changeTitle": "Change layout",
        "addDescription": "Pick a layout. The new page goes after this one.",
        "changeDescription": "Pick a layout for this page. The words move into the slots that fit.",
        "label": "Layouts",
        "card": "{layout}, {group}",
        "now": "Now",
        "groups": {
          "argument": "Argument",
          "announcement": "Announcement",
          "brand": "Brand"
        }
      },
      "fit": {
        "count": "{n} warning | {n} warnings",
        "title": "One element does not fit | {n} elements do not fit",
        "note": "The page still saves. Fix it by hand, or select it and ask Raldo to make it fit.",
        "hint": "Make the text shorter or smaller, move it, or let Raldo fit it.",
        "ask": "Ask Raldo to fit it",
        "reasons": {
          "cut-off": "The text is cut off",
          "footer": "Runs into the footer",
          "overlap": "Overlaps the {element}",
          "edge": "Runs past the page edge"
        }
      },
      "raldo": {
        "chipPage": "Page {page}",
        "startFailed": "Raldo could not start the change",
        "stopFailed": "Could not stop the change",
        "undoFailed": "Could not undo the change",
        "refused": {
          "alreadyActive": "Raldo is already changing this design.",
          "notReady": "This design is not ready to change yet.",
          "instructionEmpty": "Say what to change.",
          "instructionTooLong": "That is too long. Keep it under 1000 characters.",
          "pageMissing": "That page no longer exists.",
          "elementMissing": "That element is no longer on the page.",
          "editorRole": "Only editors can change a design.",
          "superseded": "The design changed since. This change can no longer be undone.",
          "notUndoable": "This change cannot be undone.",
          "snapshotIncomplete": "The copy from before the change is incomplete.",
          "snapshotUnavailable": "The copy from before the change is not available."
        },
        "lock": {
          "title": "Raldo is editing page {page}",
          "note": "The editor unlocks when it is done.",
          "stop": "Stop"
        },
        "steps": {
          "read": "Reading page {page}",
          "edit": "Editing the {element}",
          "editPage": "Editing the page",
          "check": "Checking the render"
        },
        "card": {
          "elementFallback": "element",
          "undo": "Undo",
          "undone": "Undone",
          "undoSuperseded": "A later change replaced this one.",
          "cancelled": "Stopped. Nothing changed.",
          "rejected": "The change did not pass the checks. Nothing changed.",
          "timedOut": "The change took too long. Nothing changed.",
          "failed": "The change failed. Nothing changed."
        }
      }
    },
    "brandStyle": {
      "make": "Make brand style",
      "building": {
        "label": "Building style · {done} of {total}",
        "title": "Still building",
        "body": "Raldo is still building your brand style. {done} of {total} layouts are done. Keep working; you get a message in your Inbox when it is ready.",
        "confirm": "Got it"
      },
      "review": {
        "action": "Review brand style",
        "title": "New brand style",
        "description": "Drawn from {design}",
        "pass": "{done} of {total} pass the checks",
        "footer": "Text fits, margins hold and colours are readable on every layout.",
        "use": "Use as brand style",
        "discard": "Discard",
        "label": "The layouts of the new brand style",
        "loading": "Loading the new brand style",
        "loadError": "Could not load the new brand style"
      },
      "dialog": {
        "title": "Make a brand style from this design",
        "description": "Raldo turns this design into the 16 layouts your brand uses.",
        "confirm": "Build in the background",
        "steps": {
          "read": "Raldo reads the look: colours, fonts and your text styles.",
          "draw": "It draws the 16 layouts in the background. You can keep working. The Inbox says when it is ready.",
          "check": "Every layout is checked first: text must fit, margins must hold, colours must be readable."
        },
        "note": "New designs use the new style. This design and the designs you already made stay as they are."
      },
      "toast": {
        "started": "Raldo is building your brand style",
        "startedBody": "You get a message in your Inbox when it is ready.",
        "startFailed": "Could not start the brand style",
        "use": "Brand style updated",
        "useBody": "New designs use it. Your existing designs stay as they are.",
        "discard": "Brand style discarded",
        "discardBody": "Your current brand style stays.",
        "decideFailed": "Could not save your choice"
      },
      "refused": {
        "role": "Only an owner or admin can change the brand style.",
        "active": "Raldo is already building a brand style.",
        "designNotReady": "This design is not ready yet.",
        "notPending": "This brand style was already decided.",
        "candidateMissing": "The new brand style is no longer there. Make it again."
      }
    }
  },
  "tabs": {
    "all": "All",
    "brandFacts": "Brand facts",
    "customerProfile": "Customer profile",
    "account": "Account",
    "billing": "Billing",
    "rankings": "Rankings",
    "aiAnswers": "AI answers",
    "socialMedia": "Social Media",
    "inbox": "Inbox",
    "sent": "Sent",
    "archive": "Archive"
  },
  "visibility": {
    "search": {
      "pages": {
        "title": "Your pages in Google",
        "source": "From the monthly search run",
        "columns": {
          "page": "Page",
          "visits": "Visits/mo",
          "keywords": "Keywords"
        },
        "topKeyword": "Top keyword: {keyword}",
        "emptyTitle": "No pages in Google yet",
        "emptyBody": "The monthly search run lists the pages of your site that Google ranks, with the visits each one gets."
      },
      "columns": {
        "status": "Status",
        "mainKeyword": "Main keyword"
      },
      "emptyTitle": "No planned pages yet",
      "emptyBody": "Once Raldo plans your pages, each page's main keyword, its searches and your rank on Google show here.",
      "openPlan": "Open the plan"
    },
    "keyword": {
      "why": "Why you can win it",
      "in": "in",
      "rankHistory": "Search rank over time",
      "weekly": "Weekly",
      "volume": "Searches a month",
      "volumeSource": "Last 12 months, from Google",
      "whoRanks": "Who ranks on Google",
      "aiOverview": "Who Google's AI Overview cites",
      "checked": "Checked {date}",
      "searchRun": "{date} search run"
    },
    "citeHelp": {
      "label": "What cited and named mean",
      "cited": "Cited",
      "citedBody": "The answer links to the site as a source. A buyer can click through to it, and AI search counts it as evidence.",
      "named": "Named",
      "namedBody": "The answer mentions the brand by name, with or without a link. It puts you in the buyer's mind but sends no visit."
    },
    "aiAnswers": {
      "figures": {
        "cited": "Prompts where AI assistants cite you",
        "citeYou": "cite you",
        "citeRival": "cite a rival instead",
        "citeNone": "cite no one you track",
        "named": "Prompts where they name you",
        "nameAndLink": "name you and link you",
        "nameNoLink": "name you without a link",
        "nameNone": "never name you",
        "overview": "Keywords where AI Overviews cite you",
        "overviewCites": "cite you",
        "overviewWithout": "answer without you",
        "overviewNone": "with no AI Overview"
      },
      "prompt": "Prompt",
      "citedBy": "Cited by {engine}",
      "noAnswer": "No answer",
      "overviews": "Google AI Overviews",
      "overviewsMeta": "Keywords where the Overview cites you or a rival",
      "overviewsEmptyTitle": "No AI Overview cites you or a rival yet",
      "overviewsEmptyBody": "When Google's AI Overview for a keyword you track cites you or a tracked rival, the keyword shows here.",
      "emptyTitle": "No AI answers yet",
      "emptyBody": "Once a month Raldo asks ChatGPT and Perplexity the questions your buyers ask, written from your plan. Measure now to get the first answers.",
      "run": {
        "working": "Raldo is measuring your AI visibility.",
        "stages": {
          "prompts": "Raldo is writing the questions your buyers ask AI assistants.",
          "answers": "Raldo is asking the AI assistants and reading their answers.",
          "commit": "Raldo is saving the answers."
        },
        "completed": "The AI answers are ready.",
        "partial": "The AI answers are ready, but some did not arrive.",
        "cancelled": "You cancelled the measurement.",
        "failed": "The measurement stopped"
      },
      "measure": "Measure now",
      "table": {
        "title": "You and your rivals in AI answers",
        "meta": "Topic and category prompts · {period}",
        "share": "Share of tracked",
        "shareHint": "Share of the names the AI answers give to you and your tracked rivals",
        "named": "Named",
        "cited": "Cited",
        "namedBy": "{engine} named",
        "citedBy": "{engine} cited",
        "answers": "{count} answer | {count} answers"
      },
      "rates": {
        "answers": "Answers",
        "byTopic": "Named rate by topic",
        "topicMeta": "Topic prompts only · {period}",
        "topic": "Topic",
        "byStage": "Named rate by stage",
        "stageMeta": "Topic and category prompts · {period}",
        "stage": "Stage"
      },
      "otherBrands": {
        "title": "Other brands named",
        "meta": "By ChatGPT, share of its answers",
        "brand": "Brand",
        "share": "Share"
      },
      "domains": {
        "title": "Top cited domains",
        "topicTitle": "Top cited domains: {topic}",
        "meta": "Answers that cite the site",
        "site": "Site"
      },
      "categoryPrompts": "Category prompts",
      "brandPrompts": "Brand prompts",
      "brandMeta": "Your own site is a source in {cited} of {answers} answers. Not in the figures above.",
      "promptCount": "{count} prompt | {count} prompts"
    },
    "prompt": {
      "asked": "· asked {date}",
      "answerFrom": "Answer from {engine}",
      "cites": "Cites",
      "webSearch": "{model} · web search",
      "noAnswer": "No answer this time. Raldo asks again in next month's run.",
      "moreSources": "{domain} +{count}",
      "sources": "{count} source | {count} sources",
      "mentions": "Who the answers mention",
      "mentionsCount": "{count} site or brand | {count} sites and brands",
      "siteOrBrand": "Site or brand",
      "mentionsEmpty": "Neither answer mentions a site or brand.",
      "you": "You",
      "trackedRival": "{domain} · tracked rival",
      "site": "Site, not tracked",
      "brand": "Brand, not tracked",
      "cited": "Cited",
      "named": "Named",
      "notFoundTitle": "Prompt not found",
      "notFoundBody": "It may be from an older run, or the link is out of date.",
      "back": "Back to AI answers",
      "writtenFrom": "Written from the page",
      "kind": {
        "category": "Category prompt",
        "brand": "Brand prompt"
      }
    },
    "social": {
      "windowAria": "Time window",
      "windowDays": "{days} days",
      "allTime": "All time",
      "figures": {
        "impressions": "Impressions",
        "impressionsSub": "Across {count} post | Across {count} posts",
        "reach": "Reach",
        "reachSub": "Summed across posts",
        "engagement": "Average engagement rate",
        "engagementSub": "Reactions, comments and shares over impressions",
        "published": "Posts published",
        "publishedSub": "of {tracked} tracked · {syncing} syncing"
      },
      "weekly": {
        "title": "Impressions by week",
        "meta": "LinkedIn · in the chosen window",
        "aria": "Impressions per week, in the chosen window"
      },
      "posts": {
        "title": "Published posts",
        "meta": "Most seen first",
        "post": "Post",
        "published": "Published",
        "impressions": "Impressions",
        "reach": "Reach",
        "engagement": "Engagement",
        "clicks": "Clicks",
        "syncing": "Syncing from LinkedIn",
        "emptyTitle": "Nothing published in this window",
        "emptyBody": "Pick a longer window to see older posts."
      },
      "emptyTitle": "No published posts yet",
      "emptyBody": "Once a post goes out on LinkedIn, Raldo syncs its impressions, reach and engagement every six hours.",
      "emptyCta": "Open the board",
      "loadError": "Could not load your social figures"
    }
  },
  "calendar": {
    "view": {
      "board": "Board",
      "calendar": "Calendar",
      "aria": "View"
    },
    "columns": {
      "review": "Needs review",
      "scheduled": "Scheduled",
      "published": "Published",
      "reviewEmpty": "Nothing to review",
      "scheduledEmpty": "Nothing scheduled",
      "publishedEmpty": "Nothing published",
      "lastDays": "Last {count} days",
      "writing": "Writing",
      "showOlder": "Show older"
    },
    "card": {
      "post": "Post",
      "postPages": "Post · {count} page | Post · {count} pages",
      "when": "{day} · {time}",
      "impressions": "impressions",
      "engagement": "engagement",
      "writingAria": "Raldo is writing this post",
      "actionsAria": "Actions for {title}"
    },
    "day": {
      "yesterday": "Yesterday",
      "today": "Today",
      "tomorrow": "Tomorrow"
    },
    "badge": {
      "writing": "Writing",
      "failed": "Failed",
      "needsPerson": "Needs a person"
    },
    "state": {
      "writing": "Writing",
      "failed": "Failed",
      "published": "Published",
      "scheduled": "Scheduled",
      "awaitingArtwork": "Awaiting artwork",
      "draft": "Draft",
      "needsPerson": "Needs a person"
    },
    "measuring": "Measuring",
    "editedByYou": "Edited by you",
    "pages": "{count} page | {count} pages",
    "openSlot": "Open slot",
    "noDateTray": "No date yet · {count}",
    "nothingPlanned": "Nothing planned",
    "dock": {
      "failed": "Failed",
      "whatItArgues": "What it argues",
      "topic": "Topic · {name}",
      "history": "History · {count} version | History · {count} versions",
      "articleState": "Where it stands",
      "writing": "Raldo is writing the sections.",
      "todo": "To do · {count} | To do · {count}",
      "more": "+ {count} more",
      "outline": "Outline",
      "verified": "Verified {date}",
      "openPublished": "Open the published page",
      "goesLive": "A page goes live when you add its published link, not by scheduling.",
      "planning": "Raldo is planning and researching this page.",
      "askArticlePlaceholder": "Ask Raldo about this page…",
      "checked": "Raldo has checked the draft.",
      "needsPerson": "Needs a person"
    },
    "toast": {
      "reconnectFirst": "Reconnect LinkedIn first.",
      "writing": "Raldo is still writing this post. It has no copy to schedule yet.",
      "article": "A page goes live when you add its published link, not by scheduling.",
      "neverPublishes": "Dragging never publishes. Open the post and use Publish now.",
      "publishedStays": "A published post stays published. LinkedIn has no edit or unpublish-and-keep.",
      "noBody": "This post has no copy to schedule yet.",
      "connectFirst": "Connect LinkedIn first."
    },
    "notConnected": "LinkedIn isn't connected, so scheduled posts can't go out."
  },
  "inbox": {
    "newNote": "New note",
    "tabsAria": "Inbox view",
    "loading": "Loading your inbox",
    "listAria": "Inbox items",
    "group": {
      "today": "Today",
      "thisWeek": "This week",
      "earlier": "Earlier"
    },
    "sender": {
      "raldo": "Raldo",
      "linkedin": "LinkedIn",
      "you": "You"
    },
    "when": "{day}, {time}",
    "note": {
      "viaTelegram": "via Telegram",
      "editAria": "Edit this note"
    },
    "composer": {
      "title": "New note",
      "add": "Add note",
      "addLink": "Add a link",
      "addImage": "Add an image",
      "linkPlaceholder": "Paste a link and press Enter",
      "hint": "Raldo reads your notes when it plans and writes."
    },
    "error": {
      "publish_failed": "LinkedIn did not accept the post.",
      "publish_partial": "The post went out on some channels but not all.",
      "linkedin_account_not_connected": "LinkedIn is not connected.",
      "design_page_render_missing": "A page of the design could not be rendered.",
      "unexpected_error": "Something unexpected went wrong.",
      "article_health_check_failed": "The article failed its health check.",
      "token_revoked": "LinkedIn access was revoked. Connect the account again.",
      "unknown": "Something went wrong.",
      "brand_style_enqueue_failed": "The brand style could not be started.",
      "brand_style_failed": "Raldo could not draw the brand style.",
      "brand_style_rejected": "The layouts did not pass the checks.",
      "run_timed_out": "The run took too long."
    },
    "toast": {
      "actionFailed": "Could not update the inbox",
      "sent": "Sent to Raldo.",
      "later": "Put aside. The orange count keeps it."
    },
    "unread": "Unread",
    "markAllRead": "Mark all as read",
    "archive": "Archive",
    "unarchive": "Unarchive",
    "deleted": "This item was deleted",
    "empty": {
      "inbox": {
        "title": "Nothing here yet.",
        "description": "Raldo writes when a draft, a question or a result needs you."
      },
      "unread": {
        "title": "You are all caught up."
      },
      "important": {
        "title": "Nothing important right now."
      },
      "sent": {
        "title": "No notes yet.",
        "description": "Anything Raldo should know lands here."
      },
      "archive": {
        "title": "Nothing archived.",
        "description": "Archived messages are kept here."
      }
    },
    "researchKind": {
      "brandFacts": "Your brand facts",
      "customerProfile": "Your customer profile",
      "contentStrategy": "Your content strategy",
      "competitors": "Your competitor analysis",
      "visibility": "Your visibility check",
      "aiAnswers": "Your AI answers check",
      "documents": "Your document research"
    },
    "selectPrompt": "Select a message",
    "build": {
      "title": "Raldo is building your plan",
      "steps": {
        "snapshot": {
          "title": "Search snapshot",
          "caption": "You in search and AI answers | You and your competitor in search and AI answers | You and your {count} competitors in search and AI answers"
        },
        "plan": {
          "title": "Content plan",
          "caption": "The pages and posts to make first"
        },
        "answers": {
          "title": "AI answers check",
          "caption": "Where ChatGPT and Perplexity name you"
        }
      }
    },
    "missing": "This message is not here any more",
    "subject": {
      "articleQuestions": "{count} question about {page} | {count} questions about {page}",
      "articleReady": {
        "completed": "{page} is ready",
        "partial": "{page} is ready, with gaps"
      },
      "planProposal": "Plan changes to review",
      "planTopics": "{count} topic to review | {count} topics to review",
      "planReminder": {
        "reviewTopics": "Still waiting: your topics",
        "reviewPlan": "Still waiting: your plan"
      },
      "planReady": {
        "completed": "Your plan is ready",
        "partial": "Your plan is ready, with gaps"
      },
      "postDraft": "Draft ready: {title}",
      "postPublishFailed": "Publish failed: {title}",
      "postPublished": "Published: {title}",
      "postResults": "Results: {title}",
      "runFailed": "{run} did not finish",
      "accountDisconnected": "{platform} disconnected",
      "researchReady": "{research} is ready",
      "designReady": {
        "no": "Your design is ready",
        "yes": "Design ready, pages missing"
      },
      "brandStyleReady": "Your new brand style is ready",
      "brandStyleDecided": {
        "used": "Brand style updated",
        "discarded": "Brand style discarded"
      }
    },
    "line": {
      "articleQuestions": "A quick one before I write on. | {count} quick ones before I write on.",
      "articleReady": {
        "completed": "Written, edited and checked. Read it when you have a moment.",
        "partial": "A few sections need your eye before it goes anywhere."
      },
      "planProposal": "{changes}. Nothing moves until you say so.",
      "planTopics": "Keep the ones you want to own. Nothing is planned until you say so.",
      "planReminder": {
        "reviewTopics": "I asked 7 days ago. The run waits; discard it if you no longer want it.",
        "reviewPlan": "I asked 7 days ago. The run waits; discard it if you no longer want it."
      },
      "planReady": {
        "completed": "Every page by topic, in the order I would write them.",
        "partial": "Some parts are missing. They are marked."
      },
      "postDraft": {
        "yes": "{hook}",
        "no": "Ready for a read."
      },
      "postPublishFailed": "{error}",
      "postPublished": "Out on LinkedIn. I will write back with the numbers in about a week.",
      "postResults": "{impressions} impressions, {clicks} clicks, {rate} engagement.",
      "runFailed": "{error}",
      "accountDisconnected": "Scheduled posts stay put until you reconnect.",
      "researchReady": {
        "brandFacts": "What I read about your company, and where I read it.",
        "customerProfile": "Who you write for, in their own words.",
        "contentStrategy": "What you stand for, and what you write about.",
        "competitors": "The other names your buyers consider, and how you compare.",
        "visibility": "Where buyers find you this month, and where they do not yet.",
        "aiAnswers": "Where ChatGPT and Perplexity name you.",
        "documents": "What I pulled from your documents."
      },
      "designReady": {
        "no": "Attached to the post. Open it to check.",
        "yes": "Some pages could not be attached to the post."
      },
      "brandStyleReady": "Drawn from {design}. Sixteen layouts to review.",
      "brandStyleDecided": {
        "used": "New designs use it from now on.",
        "discarded": "Your brand style did not change."
      }
    },
    "body": {
      "articleQuestions": [
        "I am writing {page} and hit one thing I cannot find in your sources. | I am writing {page} and hit {count} things I cannot find in your sources.",
        "Answer on the page and I will pick up where I stopped. Guessing would weaken the argument."
      ],
      "articleReady": {
        "completed": [
          "{page} is written, edited and checked. Open it to read it through and publish."
        ],
        "partial": [
          "I finished what I could of {page}. A few sections need your eye before this goes anywhere. They are marked."
        ]
      },
      "planProposal": [
        "Your buyers’ searches moved, so I propose changes to your plan: {changes}.",
        "Nothing changes until you review it."
      ],
      "planTopics": [
        "I read the searches your buyers type and propose {count} topic. | I read the searches your buyers type and propose {count} topics.",
        "Keep, rename or remove any topic, or add your own. Nothing is planned until you approve."
      ],
      "planReminder": {
        "reviewTopics": ["I asked 7 days ago. The run waits; discard it if you no longer want it."],
        "reviewPlan": ["I asked 7 days ago. The run waits; discard it if you no longer want it."]
      },
      "planReady": {
        "completed": [
          "Your content plan is in: every page by topic, in the order I would write them. Have a look."
        ],
        "partial": [
          "Your content plan is in, but I could not finish every part. The gaps are marked."
        ]
      },
      "postDraft": {
        "yes": ["Your draft is ready. It opens with: “{hook}”", "Read it once, then schedule it."],
        "no": ["Your draft is ready.", "Read it once, then schedule it."]
      },
      "postPublishFailed": [
        "LinkedIn did not take “{title}”. {error}",
        "Fix what it names and retry. I will take it from there."
      ],
      "postPublished": [
        "“{title}” is out on LinkedIn. I will check the numbers and write back in about a week."
      ],
      "postResults": ["A week in, here is how “{title}” did."],
      "runFailed": ["{run} stopped before the end. {error}", "Start it again when you are ready."],
      "accountDisconnected": [
        "{platform} dropped the connection. {error}",
        "Nothing goes out until you connect it again. Two clicks."
      ],
      "researchReady": {
        "brandFacts": [
          "I read your site and wrote down what is true about your company, with the page each fact came from. Check me."
        ],
        "customerProfile": [
          "I drew the person on the other side of your posts from what buyers say. See if you recognise them."
        ],
        "contentStrategy": [
          "Your content strategy is ready: what you stand for and what you write about. Read it and confirm it."
        ],
        "competitors": [
          "I looked at the names your buyers weigh you against, and where you stand out. Have a look."
        ],
        "visibility": [
          "This month’s check is in: where buyers find you in Google and in AI answers, and where they do not yet."
        ],
        "aiAnswers": [
          "I asked ChatGPT and Perplexity your buyers’ questions and noted where you come up."
        ],
        "documents": ["I read your documents and pulled out what I can use when I write."]
      },
      "designReady": {
        "no": [
          "Your design is drawn and attached to the post. Open it to check it before it goes out."
        ],
        "yes": [
          "Your design is drawn, but I could not attach every page to the post. Open it to see which."
        ]
      },
      "brandStyleReady": [
        "I drew a brand style from {design}: sixteen layouts in its colours and type.",
        "Use it or discard it. New designs follow it from then on."
      ],
      "brandStyleDecided": {
        "used": ["The new brand style is now your brand style. New designs use it from now on."],
        "discarded": ["You discarded the new brand style. Your brand style did not change."]
      }
    },
    "verb": {
      "articleQuestions": "Answer on the page",
      "articleReady": "Open the page",
      "planProposal": "Review the plan",
      "planTopics": "Review topics",
      "planReminder": {
        "reviewTopics": "Review topics",
        "reviewPlan": "Review plan"
      },
      "planReady": "Open the plan",
      "postDraft": "Open the post",
      "postPublishFailed": "Retry",
      "postPublished": "Open the post",
      "postResults": "Open the post",
      "runFailed": "Open",
      "accountDisconnected": "Reconnect",
      "researchReady": "Open",
      "designReady": "Open the post",
      "brandStyleReady": "Review",
      "brandStyleDecided": "Open",
      "note": "Edit"
    },
    "verbSecondary": {
      "postPublishFailed": "Open the post"
    },
    "changes": {
      "topics": "{n} topic changed | {n} topics changed",
      "added": "{n} page added | {n} pages added",
      "removed": "{n} page removed | {n} pages removed",
      "changed": "{n} page changed | {n} pages changed"
    },
    "runName": {
      "article": "The article",
      "post": "The post",
      "plan": "The plan",
      "design": "The design",
      "design-edit": "The design edit",
      "brand-style": "The brand style",
      "other": "The run"
    },
    "important": "Important",
    "later": "Later",
    "more": "+{n} in Inbox",
    "selected": "{n} selected",
    "markRead": "Mark read",
    "count": "{n} message | {n} messages",
    "selectMessage": "Select message",
    "clearSelection": "Clear selection",
    "filter": {
      "aria": "Filter messages",
      "all": "All"
    },
    "toYou": "to you",
    "toRaldo": "to Raldo",
    "earlierInThread": "Earlier in this thread",
    "position": "{n} / {total}",
    "markUnread": "Mark unread",
    "moveToInbox": "Move to Inbox",
    "previous": "Previous message",
    "next": "Next message"
  },
  "pages": {
    "write": "Write a page",
    "filterAria": "Show pages by status",
    "emptyFilter": {
      "planned": "No planned pages",
      "writing": "No pages in writing",
      "live": "No live pages",
      "site": "No pages on your site"
    },
    "emptyFilterBody": "Pick another filter to see the rest of the plan.",
    "menu": {
      "aria": "Actions for {title}",
      "open": "Open",
      "write": "Write page",
      "openAddress": "Open address",
      "copyAddress": "Copy address",
      "copied": "Address copied"
    },
    "nextUp": "Next up",
    "topics": "Topics",
    "topicsMeta": "{count} topic | {count} topics",
    "next": "Next: {question}",
    "everyPageWritten": "Every page is written",
    "backToPages": "Back to Pages"
  },
  "posts": {
    "filterAria": "Show posts by status",
    "emptyTitle": "No posts yet",
    "emptyBody": "Raldo writes a post from your arguments and research.",
    "row": {
      "text": "Text",
      "pages": "{count} page | {count} pages"
    }
  }
}
